/**
 * @description The endpoints which are done and added
 * @docURL https://documenter.getpostman.com/view/12910327/UzBgtU9t#a524cd91-8519-4bd6-8512-9c1194076ecc
 */

export const STORAGE_PUBLIC = 'https://storage.googleapis.com/tryoto-public';
export const LOCALIZATION_BASE_URL = import.meta.env.VITE_LOCALIZATION_URL;

const ACCOUNTING_BASE_URL = 'web/v1/accounting';
const INVOICE_CHECKER_BASE_URL = 'web/v1/accounting/invoiceChecker';
const ADDRESS_BASE_URL = 'web/v1/address';
const ADVANCE_WMS_BASE_URL = '/web/v1/advancewms';
const ADVANCED_OMS_BASE_URL = 'web/v1/advanced-oms';
const AUTH_BASE_URL = import.meta.env.VITE_REST_URL;
const AUTOMATION_BASE_URL = 'web/v1/automation';
const BOX_BASE_URL = 'web/v1/box';
const BRANCHES_BASE_URL = 'web/v1/branch';
const BRAND_BASE_URL = 'web/v1/brand';
const BRUSER_BASE_URL = 'web/v1/branch/user';
const COMPANY_BASE_URL = 'web/v1/company';
const CREDIT_BASE_URL = 'web/v1/credit';
const CUSTOM_ROLE_BASE_URL = 'web/v1/customRole';
const CUSTOMER_SERVICE_BASE_URL = 'web/v1/customerService';
const EMAIL_BASE_URL = 'web/v1/email';
const EXPORT_BASE_URL = 'web/v1/export';
const FORM_BASE_URL = 'web/v1/form';
const FORM_IMPORT_BASE_URL = 'web/v1/form/import';
const IMPORT_BASE_URL = 'web/v1/import';
const INVOICE_BASE_URL = 'web/v1/invoice';
const INVENTORY_SYNC_BASE_URL = 'web/v1/inventorySync';
const LOGS_BASE_URL = 'web/v1/log';
const NOTIFICATION_BASE_URL = 'web/v1/notification';
const ONBOARDING_BASE_URL = 'web/v1/onboarding';
const OPEN_BASE_URL = 'web/v1/open';
const OPEN_SMS_BASE_URL = 'web/v1/open/sms';
const OPEN_OTO_LINK_URL = 'web/v1/open/otoLink';
const ORDER_ACTIONS_BASE_URL = 'web/v1/order/actions';
const ORDER_BASE_URL = 'web/v1/order';
const OTHER_INTEGRATIONS_BASE_URL = 'web/v1/integration/other';
const OTOFLEX_BASE_URL = 'web/v1/flex';
const OTO_STORE_BASE_URL = 'web/v1/otoStore';
const OTOLINK_BASE_URL = 'web/v1/otoLink';
const PAYMENT_BASE_URL = 'web/v1/payment';
const PO_BASE_URL = 'web/v1/purchase-order';
const PRINT_BASE_URL = 'web/v1/print';
const PUBLIC_PRINT_BASE_URL = '/web/v1/open/print';
const PRODUCT_BASE_URL = 'web/v1/product';
const PRODUCT_SYNC_BASE_URL = `web/v1/productSync`;
const PROFILE_BASE_URL = 'web/v1/profile';
const USER_IDENTITY = 'web/v1/identity';
const REASON_CONFIG_BASE_URL = 'web/v1/reasonConfig';
const REFERRAL_BASE_URL = 'web/v1/referral';
const REGISTER_BASE_URL = 'web/v1/register';
const RMS_BASE_URL = 'web/v1/rms';
const SALE_CHANNEL_BASE_URL = 'web/v1/salesChannel';
const SHIPPING_AUTOMATION_BASE_URL = 'web/v1/shipping/automation';
const SHIPPING_PARTNER_BASE_URL = 'web/v1/shipping/partner';
const SMS_BASE_URL = 'web/v1/sms';
const USER_BASE_URL = 'web/v1/user';
const WAREHOUSE_BASE_URL = 'web/v1/warehouse';
const WEBHOOK_SETTINGS_BASE_URL = 'web/v1/webhook';
const WHATSAPP_BASE_URL = 'web/v1/whatsapp';
const WHUSER_BASE_URL = 'web/v1/warehouse/user';
const WMS_BASE_URL = 'web/v1/wms';
const COD_WALLET_BASE_URL = 'web/v1/cod-wallet';
const FINANCE_BASE_URL = 'web/v1/finance';
const UNIT_ECONOMICS_BASE_URL = 'web/v1/unitEconomicsModule';
const USER_GROUPS_BASE_URL = 'web/v1/usergroups';
const DELIVERY_COMPANIES_BASE_URL = 'web/v1/deliveryCompanies';
const MFA_BASE_URL = 'web/v1/mfa';
const MARKETING_BASE_URL = 'web/v1/marketing';
const IMPORT_ORDERS_ACTIONS_BASE_URL = 'web/v1/importOrder/actions';

// report
const REPORT_DASHBOARD_BASE_URL = 'web/v1/report/dashboard';
const REPORT_LIST_BASE_URL = 'web/v1/report/list';
const REPORT_ANALYSIS_BASE_URL = 'web/v1/report/analysis';
const REPORT_SLA_BASE_URL = 'web/v1/report/sla';
const REPORT_SALES_BASE_URL = 'web/v1/report/sales';
const REPORT_DELIVERY_COMPANY_BASE_URL = 'web/v1/report/dc';
const REPORT_OTO_FLEX_BASE_URL = 'web/v1/report/flex';
const REPORT_OTO_PACK_BASE_URL = 'web/v1/report/pack';
const REPORT_CUSTOMER_DETAILS_BASE_URL = 'web/v1/report/customer';
const REPORT_OTO_BASE_URL = 'web/v1/report/oto';
const REPORT_DC_BASE_URL = 'web/v1/report/dc';
// admin
const ADMIN_ENUM_BASE_URL = 'web/v1/admin/fieldEnum';
const ADMIN_STORY_BASE_URL = 'web/v1/admin/story';
const ADMIN_ROLE_BASE_URL = 'web/v1/admin/role';
const ADMIN_CONFIGURATION_BASE_URL = 'web/v1/admin/configuration';
const ADMIN_ROLE_TREE_BASE_URL = 'web/v1/admin/roleTree';
const ADMIN_SALES_CHANNELS_BASE_URL = 'web/v1/admin/salesChannels';
const ADMIN_DELIVERY_COMPANY_SETTINGS_BASE_URL = 'web/v1/admin/deliveryCompanySettings';
const ADMIN_CLIENT_BASE_URL = '/web/v1/admin/client';
const ADMIN_LANGUAGE_RESOURCE_BASE_URL = 'web/v1/admin/langResource';
const ADMIN_COUNTRIES_BASE_URL = 'web/v1/admin/countries';
const ADMIN_OTHER_INTEGRATIONS_BASE_URL = 'web/v1/admin/otherIntegrations';
const ADMIN_STATUS_BASE_URL = 'web/v1/admin/status';
const ADMIN_BASE_URL = 'web/v1/admin';

const PRICE_CALCULATOR_BASE_URL = 'web/v1/price-calculator';
const DELIVERY_SLOT_BASE_URL = 'web/v1/shipping/deliverySlot';

export const AUTOCOMPLETE = {
	AREA: 'area',
	AUTOFILL_CUSTOMER_DETAILS: 'autoFillCustomerDetails',
	AUTOMATIONS: 'automations',
	AUTOMATION_FUNCTION_TYPES: 'automationFunctionTypes',
	AUTOMATION_INTEGRATIONS: 'automationIntegrations',
	ALL_CLIENTS: 'allClients',
	BINS_BY_WAREHOUSE: 'binsByWarehouse', // Returns bins by warehouse
	BINS: 'bins', // returns all bins
	BOXES: 'boxes',
	BRANCH_USERS: 'branchUsers',
	BRANCHES_BY_COMPANY_BASED: 'branchesByCompanyBased',
	BRANCHES: 'branches',
	BRANDS: 'brands',
	DC_SETTINGS_BRAND: 'dcSettingsBrands',
	CITY_GROUPS: 'cityGroups',
	CITIES_LIST: 'citiesList',
	CLIENTS: 'clients',
	CLIENTS_FOR_INVOICE: 'clientsForInvoice',
	COMPANIES_FOR_DELIVERY_PRICE: 'companiesForDeliveryPrice',
	COUNTRIES: 'countries',
	ALL_DELIVERY_COMPANIES: 'allDeliveryCompanies',
	ALL_ACTIVE_DELIVERY_COMPANIES: 'allActiveDeliveryCompanies',
	DELIVERY_COMPANY_NAME_FOR_INVOICE: 'deliveryCompanyNameForInvoice',
	DELIVERY_COMPANY_SETTINGS: 'deliveryCompanySettings',
	DELIVERY_COMPANY_SETTINGS_RA: 'deliveryCompanySettingsRA',
	DELIVERY_COMPANY_SETTINGS_ADMIN: 'deliveryCompanySettingsAdmin',
	DELIVERY_COMPANY_SETTINGS_ACTIVE_PASSIVE: 'deliveryCompanySettingsActivePassive',
	DELIVERY_COMPANY_SETTING_ALL_CLIENTS: 'deliveryCompanySettingAllClients',
	DRIVER_USERS: 'driverUsers',
	EMAIL_ACCOUNTS: 'emailAccounts',
	FEASIBILITY_RULES_ACTIVE: 'feasibilityRulesActive',
	INVOICE_TRANSACTIONS_SHIPMENTID: 'invoiceTransactionsShipmentID',
	ORDERS: 'orders',
	OTO_PACK_USERS_BY_WAREHOUSE: 'otoPackUsersByWarehouse', // Returns oto pack users by warehouse
	OTO_PACK_USERS: 'otoPackUsers', // Returns oto pack users
	OTO_STATUSES: 'otoStatuses',
	ORDERS_BY_CLIENT: 'ordersByClient', // Returns orders by client {{clientID}}}
	ORDERS_BY_DELIVERY_COMPANY: 'ordersByDeliveryCompany',
	ORDERS_BY_COMPANY: 'ordersByCompany',
	PACKING_BINS: 'packingBins',
	SORTING_STATIONS: 'sortingStations',
	PACKING_BINS_BY_WAREHOUSE: 'packingBinsByWarehouse',
	PICKER_USERS_BY_WAREHOUSE: 'pickerUsersByWarehouse', // Returns picker users,
	PRICE_CALCULATOR_ORDERS: 'priceCalculatorOrder',
	GET_ESTIMATE_IMPORT_ORDERS: 'getEstimateImportOrder',
	PRODUCT_GROUP: 'productGroup',
	PRODUCTS: 'products',
	PRODUCTS_BY_CURRENCY: 'productsByCurrency',
	PUT_AND_PICK_BINS: 'putAndPickBins',
	PUT_AND_PICK_BINS_BY_WAREHOUSE: 'putAndPickBinsByWarehouse',
	PUT_AND_PICK_BINS_BY_BIN_ID: 'putAndPickBinsByBinID',
	RECEIVE_BINS: 'receiveBins', // Returns "receiveAndTransfer","adjustment","storageAndQc","returnBin",
	ROLE_TEMPLATES: 'roleTemplates',
	ROLE_TREE: 'roleTree',
	ROLES: 'roles',
	SALES_CHANNELS: 'salesChannels',
	SMS_CONFIG: 'smsConfig',
	USERS: 'users',
	USER_GROUPS: 'userGroups',
	V2ROLES: 'v2Roles',
	VENDOR: 'vendor',
	WAREHOUSE_USERS: 'warehouseUsers',
	WAREHOUSES: 'warehouses',
	WAREHOUSES_BY_COMPANY_BASED: 'warehousesByCompanyBased',
	WAREHOUSES_WAREHOUSE_USER_BASED: 'warehousesWarehouseUserBased',
	ZONE_BY_WAREHOUSE: 'zoneByWarehouse',
	SYSTEM_ROLES: 'systemRoles',
	SYSTEM_PACKAGES: 'systemPackages',
	PACKAGE_PICK_LIST: 'packagePicklist',
	CLIENT_PICK_LIST: 'clientPickList',
	LOCKERS: 'lockers',
	STATUS_GROUP: 'statusGroup',
	CUSTOM_GROUP: 'customGroup',
	ENTERPRISE_CLIENTS: 'enterpriseClients'
};

export const ENUMS = {
	ACTIVE_DC_SETTINGS: 'ActiveDCSettings',
	ACTIVE_INACTIVE: 'ActiveInactive',
	ACTIVE_PASSIVE: 'ActivePassive',
	ALL_STATUSES: 'allStatuses',
	AUTOMATION_CONDITIONS: 'AutomationConditions',
	AUTOMATION_TRIGGER_STATUSES: 'automationTriggerStatuses',
	AWAITING_PICKUP_STATUS: 'awaitingPickup.status',
	BIGCOMMERCE_CREDENTIALS_STATUSES: 'bigcommerceCredentialsStatuses',
	BIN_TYPE: 'binType',
	BR_AWAITING_PICKUP_STATUS: 'brWaitingPickup.status',
	BR_CANCELED_STATUS: 'brCanceledOrders.status',
	BR_DELIVERED_STATUS: 'brDeliveredOrders.status',
	BR_PENDING_ORDERS_STATUS: 'brPendingOrders.status',
	BR_RETURNED_STATUS: 'brReturnedOrders.status',
	BR_SHIPMENT_IN_PROGRRESS_ORDERS_STATUS: 'brShipmentInProgress.status',
	BR_UNASSIGNED_ORDERS_STATUS: 'brUnassigned.status',
	BRANCHES: 'Branches',
	BRAND_NAME: 'brandName',
	CANCEL_REASON_CONFIG: 'CancelReasonConfig',
	MARK_AS_NOT_AVAILABLE_REASON_CONFIG: 'MarkAsNotAvailableReasonConfig',
	CANCELED_ORDERS_STATUS: 'canceledOrders.status',
	CONFIRMATION_STATUS_LIST_ENUM: 'ConfirmationStatusListEnum',
	CREDIT_TRANSACTION_STATUS: 'creditTransaction.status',
	CR_DOC_STATUS: 'CRDocStatuses',
	COD_TYPE: 'CODType',
	COMPANY_TYPE: 'CompanyType',
	COUNTRY_BANKS: 'CountryBanks',
	COUNTRIES: 'CountryEnum',
	COD_REPORT_STATUS: 'CODReportStatus',
	CORRECTION_STATUS: 'correctionStatus',
	CURRENCY: 'Currency',
	CURRENTLY_SHIPPING_STATUS: 'currentlyShipping.status',
	DELIVERY_PROMISE: 'deliveryPromise',
	DAY_OF_WEEK: 'DayOfWeek',
	DC_CITY_TIER: 'DCCityTier',
	DC_DISTRICT_TIER: 'DCDistrictTier',
	DC_COUNTRIES: 'DCCountries',
	DC_FEASIBILITY_RULE_ACTIONS: 'DCFeasibilityRuleActions',
	DC_SERVICE_TYPES: 'DCServiceTypes',
	DC_CONTRACT_SERVICE_TYPES: 'DCContractServiceTypes',
	DEFAULT_CREDENTIALS_STATUSES: 'defaultCredentialsStatuses',
	IKAS_CREDENTIALS_STATUSES: 'ikasCredentialsStatuses',
	INVOICE_CHECKER_DIFFERENCE_TYPES: 'InvoiceCheckerDifferenceTypes',
	DELIVERED_STATUS: 'delivered.status',
	DELIVERY_COMPANIES_USED: 'DeliveryCompaniesUsed',
	DELIVERY_COMPANIES: 'deliveryCompanies',
	DELIVERY_COMPANY_BY_NAME: 'DeliveryCompanyByCompanyName',
	DELIVERY_COMPANY_SETTINGS_FOR_AGGREGATORS: 'DeliveryCompanySettingsForAggregators',
	DELIVERY_COMPANY_SETTINGS_FOR_AGGREGATORS_WITH_OMNI: 'OmniDeliveryCompanySettings',
	DRIVER_ASSIGNMENT_METHOD_STARTER_SCALE: 'driverAssignmentMethodStarterScale',
	DRIVER_ASSIGNMENT_METHOD: 'driverAssignmentMethod',
	DRIVER_CASH_TRANSACTION_TYPE: 'driverCashTransactionType',
	DRIVER_DUTY: 'driverDuty',
	ENUM_TYPES: 'enumTypes',
	EMAIL_SENDER_TYPE: 'emailSenderType',
	EMAIL_TEMP_STATUS: 'EmailTempStatus',
	EMAIL_TEMP_TYPES_V2: 'EmailTempTypesV2',
	EMAIL_TEMP_TYPES_V2_ENTERPRISE: 'EmailTempTypesV2EnterPrise',
	EMAIL_TO_CLIENT_TYPES: 'emailToClientTypes',
	FEASIBILITY_CONDITIONS_ENTERPRISE: 'FeasibilityConditionsEnterprise',
	FEASIBILITY_CONDITIONS_SCALE: 'FeasibilityConditionsScale',
	FEASIBILITY_STATUS: 'FeasibilityStatus',
	AREA_PRIORITY: 'AreaPriority',
	FIELD_TYPES: 'FieldTypes',
	FLEX_HISTORY_ORDERS_STATUS: 'flexHistoryOrders.status',
	FLEX_PROCESSING_ORDERS_STATUS: 'flexProcessingOrders.status',
	FLEX_UNASSIGNED_ORDERS_STATUS: 'flexUnassigned.status',
	GET_FAILED_DELIVERY_STATUS: 'failedDeliverOrders.status',
	HISTORY_ORDER_STATUS: 'historyOrders.status',
	INVENTORY_ORDER_STATUS: 'InventoryOrderStatus',
	INV_TRANS_TYPE: 'InvTransType',
	INV_TRANSACTIONS_ACTION: 'InvTransactionsAction',
	LANGUAGE_CODES: 'languageCodes',
	LANGUAGE: 'language',
	LOST_OR_DAMAGED_STATUSES: 'lostOrDamagedStatuses',
	MAGENTO_SETTINGS_OTO_STATUS: 'MagentoSettingsOtoStatus',
	MODULE_CATEGORIES: 'moduleCategories',
	MS_UPDATE_TYPE: 'MS_UpdateType',
	NEW_PICKUP_TYPES: 'NewPickupTypes',
	NEW_DELIVERY_TYPES: 'NewDeliveryTypes',
	ON_HOLD_ORDER_STATUS: 'onholdOrders.status',
	ON_HOLD_REASON_CONFIG: 'OnHoldReasonConfig',
	OPENCART_CREDENTIALS_STATUSES: 'opencartCredentialsStatuses',
	ORDER_DOCUMENT_TYPES: 'orderDocumentTypes',
	ORDER_OTOMATION_CONDITIONS: 'orderOtomationConditions',
	ORDER_OTOMATION_LOCATION_TYPES: 'orderOtomationLocationTypes',
	ORDER_OTOMATION_PRIORITY_METHODS: 'orderOtomationPriorityMethods',
	ORDERS_BY_PRODUCT_REPORT_DELIVERY_COMPANY: 'ordersByProductReport.deliveryCompany',
	OTO_OMS_STATUS: 'otoOmsStatus',
	OTHER_INTEGRATION_TYPES: 'otherIntegrationTypes',
	OTO_V2_ACTION_PAGES: 'OTOV2ActionPages',
	OTO_V2_ACTION_ROLES: 'OTOV2ActionRoles',
	PACKAGE_TYPE: 'packageType',
	PACKING_STATUS: 'PackingStatus',
	PAYMENT_METHOD_FOR_LIST: 'paymentMethodForList',
	PAYMENT_METHOD_WITH_PROVIDER: 'paymentMethodWithProvider',
	PAYMENT_METHOD: 'paymentMethod',
	PAYMENT_TYPE_FEASIBILITY_V2: 'PaymentTypeFeasibilityV2',
	PENDING_ORDERS_STATUS: 'pendingOrders.status',
	PICKING_METHOD: 'pickingMethod',
	PICKUP_DROPOFF: 'PickupDropoff',
	PICKUP_LOCATION: 'pickupLocation',
	PICKUP_TYPES: 'PickupTypes',
	PRICE_CONFIGURATION_BASE_PRICE_METHOD_TYPE: 'PriceConfigurationBasePriceMethodType',
	PRICE_CONFIGURATION_CHARGING_STATUS: 'PriceConfigurationChargingStatus',
	PRICE_CONFIGURATION_DAYS: 'priceConfigurationDays',
	PRICE_CONFIGURATION_DELIVERY_TYPE: 'priceConfigurationDeliveryType',
	PRICE_CONFIGURATION_PICKUP_DROPOFF: 'PriceConfigurationPickupDropoff',
	PRICE_CONFIGURATION_PICKUP_TYPE: 'priceConfigurationPickupType',
	PRICE_CONFIGURATION_SERVICE_TYPE: 'PriceConfigurationServiceType',
	PRICE_CONFIGURATION_SHIPMENT_TYPE: 'PriceConfigurationShipmentType',
	PRICE_CONFIGURATION_SLA_METHOD_TYPE: 'PriceConfigurationSLAMethodType',
	PRICE_CONFIGURATION_TIER_TYPE: 'priceConfigurationTierType',
	PRICE_CONFIGURATION_TRACKING_TYPE: 'priceConfigurationTrackingType',
	PRICE_CONFIGURATION_V2_SMB_CLIENT_TYPES: 'PriceConfigurationV2SMBClientTypes',
	PRIORITY_METHODS_ENTERPRISE: 'PriorityMethodsEnterprise',
	PRIORITY_METHODS_SCALE: 'PriorityMethodsScale',
	PROCESSING_ORDERS_STATUS: 'processingOrders.status',
	PRODUCT_ATTRIBUTE_TYPES: 'productAttributeTypes',
	PROOF_OF_DELIVERY_TYPE: 'ProofOfDeliveryType',
	PROOF_OF_PICKUP_TYPE: 'ProofOfPickupType',
	RETURN_APPROVAL_STATUS: 'returns.returnApprovalStatus',
	RETURN_REASON_CONFIG: 'ReturnReasonConfig',
	RETURN_STATUS: 'returnStatus',
	RETURN_TYPE: 'returnType',
	RETURNED_ORDERS_STATUS: 'returnedOrders.status',
	REVERSE_SHIPMENT_STATUS: 'returnShipmentStatus',
	ROLE_NAMES: 'RoleNames',
	ROLE_TREE_TYPE: 'roleTreeType',
	SALLA_CRENDENTIALS_STATUSES: 'sallaCredentialsStatuses',
	SEND_SMS_TYPES: 'sendSMSTypes',
	SHIPMENT_TYPE: 'shipmentType',
	SHIPMENT_FLOW: 'shipmentFlow', // ['Forward', 'Reverse']
	DELAY_TYPE: 'delayType', // ['pickup', 'delivery', 'reversePickup', 'reverseDelivery']
	STORY_TYPES: 'storyTypes',
	SHIPPING_PRICE_AGREEMENT_TYPE: 'ShippingPriceAgreementType',
	SLA_TYPES: 'slaTypes',
	SYLIUS_CREDENTIALS_STATUSES: 'syliusCredentialsStatuses',
	TRACKING_URL_TYPE: 'TrackingURLType',
	TSOFT_CRENDENTIALS_STATUSES: 'tsoftCredentialsStatuses',
	USER_STATUSES: 'userStatuses',
	USAGE_MODE: 'UsageMode',
	USER_SLA_METHOD_TYPE: 'UserSLAMethodType',
	V2_CLIENT_TYPES: 'v2ClientTypes',
	V2_DATE_FORMATS: 'V2DateFormats',
	V2_SHOW_ON_SCREEN: 'v2ShowOnScreen',
	V2_SMS_TYPES: 'v2SMSTypes',
	V2_USER_TYPES: 'V2UserTypes',
	WAREHOUSES: 'Warehouse',
	WEBHOOK_METHOD: 'WebhookMethod',
	WEBHOOK_TYPE: 'webhookType',
	WH_HISTORY_STATUS: 'whHistory.status',
	WH_PENDING_ORDER_STATUS: 'whPendingOrder.status',
	WH_SHIPMENT_INPROGRESS_STATUS: 'whShipmentInProgress.status',
	WH_SHIPMENT_ONHOLD_STATUS: 'whShipmentOnHold.status',
	WH_WAITING_PICKUP_STATUS: 'whWaitingPickup.status',
	WH_WORKING_STATUS: 'whWorkingStatus',
	WOOCOMMERCE_CREDENTIALS_STATUSES: 'woocommerceCredentialsStatuses',
	SHAHBANDR_CREDENTIALS_STATUSES: 'shahbandrCredentialsStatuses',
	TRENDYOL_CREDENTIALS_STATUSES: 'trendyolCredentialsStatuses',
	YES_NO: 'yesNo',
	ZID_CREDENTIALS_STATUSES: 'zidCredentialsStatuses',
	INVENTORY_CALCULATE_METHOD: 'inventoryCalculateMethod',
	INVENTORY_UPDATE_METHOD: 'inventoryUpdateMethod',
	INSTRUCTION_TYPE: 'instructionType',
	SUCCESS_FAILURE: 'successFailure',
	SORTING_STATUS: 'sortingStatus',
	INVENTORY_STATUS: 'inventoryStatus',
	SALES_CHANNEL_ACTIVE: 'MyActiveSalesChannels',
	CLIENT_PLANS: 'clientPlan',
	COD_STATUS: 'codStatus',
	COD_DESCRIPTIONS: 'CODDescriptions',
	PRODUCT_SERIAL_TYPE: 'productSerialType',
	WAVE_CREATION_TYPE_OF_ORDERS: 'waveCreationTypeOfOrders',
	TIME_SLOT_INTERVAL: 'timeSlotInterval',
	CUTOFF_TIME: 'cutoffTime',
	COHORTS: 'cohorts',
	ZERO_DC_RESULT_DESCRIPTIONS: 'zeroDCResultsDescriptions',
	PRICE_CALCULATOR_MARGIN_TYPE: 'otoMarginType', // AMOUNT, PERCENTAGE
	CLIENT_TRANSACTION_ACTION_TYPE: 'ClientTransactionActionType',
	UNIT_OF_MEASUREMENT: 'metricTypes',
	PAYMENT_GATEWAY_TYPE: 'paymentGatewayType',
	PROMO_CODE_TYPE: 'promocodeType',
	PROMO_CODE_CREDIT_TYPE: 'creditType',
	SUBSCRIPTION_PAYMENT_TYPE: 'subscriptionPaymentType',
	OTO_FEE_TYPE: 'otoFeeType',
	ECOM_TRANSACTION_DESCRIPTIONS: 'ecomTransactionDescriptions',
	REFUND_ALLOWED_STATUS: 'refundAllowedStatus',
	RETURN_METHOD: 'returnMethod',
	STATUS_GROUP_TYPES: 'statusGroupTypes',
	REFUND_CANCELLED_TYPE: 'refundCanceledType', // canceledWithoutPeriod - pendingForRefund - fraud - noFraud
	SALES_CHANNELS_FORMS: 'salesChannelFormTypes',
	PICKUP_SLA_COMPLIANCE: 'pickupSLACompliance',
	DELIVERY_ATTEMPT_SLA_COMPLIANCE: 'deliveryAttemptSLACompliance',
	DELIVERED_SLA_COMPLIANCE: 'deliveredSLACompliance',
	OTOLINK_STATUSES: 'otoLinkStatuses',
	STATUS_MAPPING_ACTIONS: 'statusMappingAction',
	HOME_PAGE_CLIENT_PLANS: 'homePageClientPlans',
	ANNOUNCEMENT_ACTION_TYPES: 'announcementActionTypes',
	SALLA_SYNC_INTERVAL: 'sallaSyncInterval'
};

export const OPEN = {
	GET_LANGUAGE_RESOURCE: `${OPEN_BASE_URL}/getLanguageResource`,
	PASSWORD_RESET: `${OPEN_BASE_URL}/requestPasswordReset`,
	UPDATE_PASSWORD: `${OPEN_BASE_URL}/updatePassword`,
	GET_ACTIVE_COUNTRIES: `${OPEN_BASE_URL}/getActiveCountries`,
	UPLOAD_FILE: `${OPEN_BASE_URL}/uploadFile`,
	GET_TRACKING_URL: `${OPEN_BASE_URL}/getUniversalTrackingLink`,
	GET_OTO_FLEX_TRACKING_INFO: `${OPEN_BASE_URL}/getOTOFlexTrackingInfo`,
	LOGO_INTEGRATION_SIGNUP: `${OPEN_BASE_URL}/logoIntegration/logoSignUp`,

	SMS: {
		GET_TRACKING_SMS_DETAILS: `${OPEN_SMS_BASE_URL}/getTrackingSMSDetails`,
		GET_ADDRESS_VERIFICATION_SMS_DETAILS: `${OPEN_SMS_BASE_URL}/getAddressVerificationSMSDetails`,
		UPDATE_ADDRESS_VERIFICATION_SMS_DETAILS: `${OPEN_SMS_BASE_URL}/updateAddressVerificationSMSDetails`,
		GET_FEEDBACK_SMS_DETAILS: `${OPEN_SMS_BASE_URL}/getFeedbackSMSDetails`,
		UPDATE_FEEDBACK_SMS_DETAILS: `${OPEN_SMS_BASE_URL}/updateFeedbackSMSDetails`,
		GET_UNDELIVERED_ATTEMPT_SMS_DETAILS: `${OPEN_SMS_BASE_URL}/getUndeliveredAttemptSMSDetails`,
		UPDATE_UNDELIVERED_ATTEMPT_SMS_DETAILS: `${OPEN_SMS_BASE_URL}/updateUndeliveredAttemptSMSDetails`,
		GET_RETURN_REQUEST_SMS_DETAILS: `${OPEN_SMS_BASE_URL}/getReturnRequestSMSDetails`,
		UPDATE_RETURN_REQUEST_SMS_DETAILS: `${OPEN_SMS_BASE_URL}/updateReturnRequestSMSDetails`,
		GET_ORDER_CONFIRMATION_SMS_DETAILS: `${OPEN_SMS_BASE_URL}/getOrderConfirmationSMSDetails`,
		UPDATE_ORDER_CONFIRMATION: `${OPEN_SMS_BASE_URL}/updateOrderConfirmation`,

		GET_RESCHEDULE_SMS_DETAILS: `${OPEN_SMS_BASE_URL}/getRescheduleSMSDetails`,
		UPDATE_RESCHEDULE_SMS_DETAILS: `${OPEN_SMS_BASE_URL}/updateRescheduleSMSDetails`,
		CANCEL_ORDER_RESCHEDULE_SMS_DETAILS: `${OPEN_SMS_BASE_URL}/cancelRescheduleSMSDetails`,
		GET_DELIVERY_SLOT_DETAILS: `${OPEN_SMS_BASE_URL}/getScheduleDeliverySlot`,
		UPDATE_DELIVERY_SLOT_DETAILS: `${OPEN_SMS_BASE_URL}/setDeliverySlot`,
		GET_BULLET_CONFIRMATION_SMS_DETAILS: `${OPEN_SMS_BASE_URL}/getBulletConfirmationSMSDetails`,
		UPDATE_BULLET_CONFIRMATION_ADDRESS: `${OPEN_SMS_BASE_URL}/bulletConfirmationUpdateAddress`,
		CONFIRM_BULLET_DELIVERY: `${OPEN_SMS_BASE_URL}/confirmBulletDelivery`
	},
	// OPEN PAYMENT
	POST_SUBSCRIPTION_FIRST_PAYMENT_RESULT: `${OPEN_BASE_URL}/postSubscriptionFirstPaymentResult`
};

export const NOTIFICATION = {
	GET_NOTIFICATION_SETTINGS: `${NOTIFICATION_BASE_URL}/getNotificationSettings`,
	UPDATE_NOTIFICATION_SETTINGS: `${NOTIFICATION_BASE_URL}/updateNotificationSettings`,
	GET_NOTIFICATIONS: `${NOTIFICATION_BASE_URL}/getNotificationList`,
	UPDATE_NOTIFICATION_READ: `${NOTIFICATION_BASE_URL}/updateNotificationRead`,
	UPDATE_ALL_NOTIFICATION_READ: `${NOTIFICATION_BASE_URL}/updateAllNotificationRead`
};

export const FORM = {
	GET_ENUM: `${FORM_BASE_URL}/getEnum`,
	GET_AUTOCOMPLETE: `${FORM_BASE_URL}/autocomplete`,
	UPLOAD_FILE: `${FORM_BASE_URL}/uploadFile`
};

export const ADMIN = {
	ROLE: {
		ADD_ROLES: `${ADMIN_ROLE_BASE_URL}/addRole`,
		UPDATE_ROLES: `${ADMIN_ROLE_BASE_URL}/updateRole`,
		DELETE_ROLES: `${ADMIN_ROLE_BASE_URL}/deleteRole`,
		GET_ROLES_LIST: `${ADMIN_ROLE_BASE_URL}/getRoleList`,
		GET_ROLE_BY_ID: `${ADMIN_ROLE_BASE_URL}/getRole`
	},
	ENUM: {
		GET_ENUM_LIST: `${ADMIN_ENUM_BASE_URL}/getFieldEnumList`,
		ADD_ENUM: `${ADMIN_ENUM_BASE_URL}/addFieldEnum`,
		UPDATE_ENUM: `${ADMIN_ENUM_BASE_URL}/updateFieldEnum`
	},
	STORY: {
		GET_STORY_LIST: `${ADMIN_STORY_BASE_URL}/getStoryList`,
		ADD_STORY: `${ADMIN_STORY_BASE_URL}/addStory`,
		UPDATE_STORY: `${ADMIN_STORY_BASE_URL}/updateStory`,
		DELETE_STORY: `${ADMIN_STORY_BASE_URL}/deleteStory`,
		GET_STORY: `${ADMIN_STORY_BASE_URL}/getStory`,
		PUBLISH_STORY: `${ADMIN_STORY_BASE_URL}/publishStory`
	},
	ROLE_TREE: {
		ADD_ROLE_TREE_RECORD: `${ADMIN_ROLE_TREE_BASE_URL}/addRoleTreeRecord`,
		UPDATE_ROLE_TREE_RECORD: `${ADMIN_ROLE_TREE_BASE_URL}/updateRoleTreeRecord`,
		DELETE_ROLE_TREE_RECORD: `${ADMIN_ROLE_TREE_BASE_URL}/deleteRoleTreeRecord`,
		GET_ROLE_TREE_RECORD: `${ADMIN_ROLE_TREE_BASE_URL}/getRoleTreeRecord`,
		GET_ROLE_TREE_LIST: `${ADMIN_ROLE_TREE_BASE_URL}/getRoleTreeList`
	},
	LANGUAGE_RESOURCE: {
		ADD_LANGUAGE_RESOURCE: `${ADMIN_LANGUAGE_RESOURCE_BASE_URL}/addLangResource`,
		UPDATE_LANGUAGE_RESOURCE: `${ADMIN_LANGUAGE_RESOURCE_BASE_URL}/updateLangResource`,
		DELETE_LANGUAGE_RESOURCE: `${ADMIN_LANGUAGE_RESOURCE_BASE_URL}/deleteLangResource`,
		GET_LANGUAGE_RESOURCE: `${ADMIN_LANGUAGE_RESOURCE_BASE_URL}/getLangResourceById`,
		GET_LANGUAGE_RESOURCE_LIST: `${ADMIN_LANGUAGE_RESOURCE_BASE_URL}/getLangResourceList`
	},
	CONFIGURATION: {
		GET_SUBSCRIPTION_LISTINGS: `${ADMIN_CONFIGURATION_BASE_URL}/getSubscriptionList`,
		GET_SUBSCRIPTION_TRANSACTIONS_LISTINGS: `${ADMIN_CONFIGURATION_BASE_URL}/getSubscriptionTransactionsList`,
		UPDATE_SUSPEND_CLIENTS: `${ADMIN_CONFIGURATION_BASE_URL}/updateSuspendClients`,
		GET_MODULES_LIST: `${ADMIN_CONFIGURATION_BASE_URL}/getModulesList`,
		GET_MODULE: `${ADMIN_CONFIGURATION_BASE_URL}/getModule`,
		ADD_MODULE: `${ADMIN_CONFIGURATION_BASE_URL}/addModule`,
		UPDATE_MODULE: `${ADMIN_CONFIGURATION_BASE_URL}/updateModule`,
		GET_PACKAGE: `${ADMIN_CONFIGURATION_BASE_URL}/getPackage`,
		ADD_PACKAGE: `${ADMIN_CONFIGURATION_BASE_URL}/addPackage`,
		UPDATE_PACKAGE: `${ADMIN_CONFIGURATION_BASE_URL}/updatePackage`,
		GET_PACKAGES_LIST: `${ADMIN_CONFIGURATION_BASE_URL}/getPackageList`,
		GET_COHORT_AGGREGATOR_ANALYSIS: `${ADMIN_CONFIGURATION_BASE_URL}/getCohortAggregatorAnalysis`,
		GET_COHORT_AGGREGATOR_DISTRIBUTION: `${ADMIN_CONFIGURATION_BASE_URL}/getCohortAggregatorDistribution`,
		GET_COHORT_INTEGRATOR_ANALYSIS: `${ADMIN_CONFIGURATION_BASE_URL}/getCohortIntegratorAnalysis`,
		GET_COHORT_INTEGRATOR_DISTRIBUTION: `${ADMIN_CONFIGURATION_BASE_URL}/getCohortIntegratorDistribution`,
		UPDATE_SUBSCRIPTION_INVOICE: `${ADMIN_CONFIGURATION_BASE_URL}/updateSubscriptionInvoices`
	},
	CLIENT: {
		GET_CLIENT_LISTINGS: `${ADMIN_CLIENT_BASE_URL}/getClientList`,
		GET_CLIENT: `${ADMIN_CLIENT_BASE_URL}/getClient`,
		UPDATE_CLIENT: `${ADMIN_CLIENT_BASE_URL}/updateClient`
	},
	SALES_CHANNELS: {
		GET_LIST: `${ADMIN_SALES_CHANNELS_BASE_URL}/getSalesChannels`,
		GET_DETAILS: `${ADMIN_SALES_CHANNELS_BASE_URL}/getSalesChannelDetails`,
		CREATE_CHANNEL: `${ADMIN_SALES_CHANNELS_BASE_URL}/createSalesChannel`,
		UPDATE_CHANNEL: `${ADMIN_SALES_CHANNELS_BASE_URL}/updateSalesChannel`
	},
	DELIVERY_COMPANY_SETTINGS: {
		GET_DC_LIST: `${ADMIN_DELIVERY_COMPANY_SETTINGS_BASE_URL}/getDeliveryCompanySettings`,
		GET_DC_DETAILS: `${ADMIN_DELIVERY_COMPANY_SETTINGS_BASE_URL}/getDeliveryCompanySettingsDetails`,
		ADD_DC_SETTINGS: `${ADMIN_DELIVERY_COMPANY_SETTINGS_BASE_URL}/createDeliveryCompanySettings`,
		UPDATE_DC: `${ADMIN_DELIVERY_COMPANY_SETTINGS_BASE_URL}/updateDeliveryCompanySettings`,
		GET_POLYGON_COVERAGE_LIST: `${ADMIN_DELIVERY_COMPANY_SETTINGS_BASE_URL}/getPolygonCoverage`,
		GET_POLYGON_COVERAGE_DETAILS: `${ADMIN_DELIVERY_COMPANY_SETTINGS_BASE_URL}/getPolygonCoverageDetails`,
		ADD_POLYGON_COVERAGE_SETTINGS: `${ADMIN_DELIVERY_COMPANY_SETTINGS_BASE_URL}/createPolygonCoverage`,
		UPDATE_POLYGON_COVERAGE: `${ADMIN_DELIVERY_COMPANY_SETTINGS_BASE_URL}/updatePolygonCoverage`,
		DELETE_POLYGON_COVERAGE: `${ADMIN_DELIVERY_COMPANY_SETTINGS_BASE_URL}/deletePolygonCoverage`,
		GET_PICKUP_CITIES: `${ADMIN_DELIVERY_COMPANY_SETTINGS_BASE_URL}/getPickupCities`,
		UPDATE_DCS_STATUS: `${ADMIN_DELIVERY_COMPANY_SETTINGS_BASE_URL}/updateDCStatus`,
		UPDATE_PICKUP_CITITES_STATUS: `${ADMIN_DELIVERY_COMPANY_SETTINGS_BASE_URL}/updatePickupCityStatus`,
		DC_SETTINGS_TEST_CONNECTION: `${ADMIN_DELIVERY_COMPANY_SETTINGS_BASE_URL}/testDCConnection`
	},
	COUNTRIES: {
		GET_COUNTRY_LIST: `${ADMIN_COUNTRIES_BASE_URL}/getCountriesList`,
		GET_COUNTRY_DETAILS: `${ADMIN_COUNTRIES_BASE_URL}/getCountryDetails`,
		ADD_COUNTRY: `${ADMIN_COUNTRIES_BASE_URL}/addCountry`,
		UPDATE_COUNTRY: `${ADMIN_COUNTRIES_BASE_URL}/updateCountry`
	},
	OTHER_INTEGRATIONS: {
		GET_OTHER_INTEGRATIONS_LIST: `${ADMIN_OTHER_INTEGRATIONS_BASE_URL}/getOtherIntegrationList`,
		ADD_OTHER_INTEGRATIONS: `${ADMIN_OTHER_INTEGRATIONS_BASE_URL}/addOtherIntegration`,
		UPDATE_OTHER_INTEGRATIONS: `${ADMIN_OTHER_INTEGRATIONS_BASE_URL}/updateOtherIntegration`,
		DELETE_OTHER_INTEGRATIONS: `${ADMIN_OTHER_INTEGRATIONS_BASE_URL}/deleteOtherIntegration`,
		GET_OTHER_INTEGRATION_BY_ID: `${ADMIN_OTHER_INTEGRATIONS_BASE_URL}/getOtherIntegration`
	},
	STATUS_MANAGEMENT: {
		GET_DC_STATUS_MAPPING_LIST: `${ADMIN_STATUS_BASE_URL}/getDCStatusMappingList`,

		ADD_DC_STATUS_MAPPING: `${ADMIN_STATUS_BASE_URL}/addDCStatusMapping`,
		GET_DC_STATUS_MAPPING: `${ADMIN_STATUS_BASE_URL}/getDCStatusMapping`,
		EDIT_DC_STATUS_MAPPING: `${ADMIN_STATUS_BASE_URL}/updateDCStatusMapping`,
		DELETE_DC_STATUS_MAPPING: `${ADMIN_STATUS_BASE_URL}/deleteDCStatusMapping`,

		GET_OTO_ORDER_STATUS_LIST: `${ADMIN_STATUS_BASE_URL}/getOtoOrderStatusList`,

		GET_OTO_ORDER_STATUS: `${ADMIN_STATUS_BASE_URL}/getOtoOrderStatus`,
		ADD_OTO_ORDER_STATUS: `${ADMIN_STATUS_BASE_URL}/addOtoOrderStatus`,
		EDIT_OTO_ORDER_STATUS: `${ADMIN_STATUS_BASE_URL}/updateOtoOrderStatus`,
		DELETE_OTO_ORDER_STATUS: `${ADMIN_STATUS_BASE_URL}/deleteOtoOrderStatus`,

		GET_STATUS_GROUPS_LIST: `${ADMIN_STATUS_BASE_URL}/getStatusGroupList`,

		ADD_STATUS_GROUP: `${ADMIN_STATUS_BASE_URL}/addStatusGroup`,
		DELETE_STATUS_GROUP: `${ADMIN_STATUS_BASE_URL}/deleteStatusGroup`,

		GET_MISSING_STATUS_MAPPING_GROUPED_LIST: `${ADMIN_STATUS_BASE_URL}/getMissingDCStatusMappingReportGrouped`,
		GET_MISSING_STATUS_MAPPING_DETAILED_LIST: `${ADMIN_STATUS_BASE_URL}/getMissingDCStatusMappingReportList`,

		UPDATE_MISSING_DC_STATUS_MAPPING: `${ADMIN_STATUS_BASE_URL}/updateMissingDCStatusMappingReport`,

		GET_ALLOWED_GROUP_STATUS_TRANSITION_LIST: `${ADMIN_STATUS_BASE_URL}/getAllowedGroupStatusTransitionList`,

		ADD_ALLOWED_GROUP_STATUS_TRANSITION: `${ADMIN_STATUS_BASE_URL}/addAllowedGroupStatusTransition`,
		DELETE_ALLOWED_GROUP_STATUS_TRANSITION: `${ADMIN_STATUS_BASE_URL}/deleteAllowedGroupStatusTransition`
	},
	REFERRALS: {
		REFERRAL_LIST: `${ADMIN_BASE_URL}/getReferrals`,
		BLOCK_REFERRAL: `${ADMIN_BASE_URL}/blockReferral`,
		UNBLOCK_REFERRAL: `${ADMIN_BASE_URL}/unblockReferral`
	},
	GET_EXTRA_CREDIT_FOR_SMB: `${ADMIN_BASE_URL}/getExtraCreditsForSMB`,
	GET_EXTRA_CREDIT_FOR_ENTERPRISE: `${ADMIN_BASE_URL}/getExtraCreditForEnterprise`,
	GET_EXTRA_FREE_SHIPMENT_CREDIT_BY_ID: `${ADMIN_BASE_URL}/getExtraFreeShipmentCredit`,
	UPDATE_EXTRA_FREE_SHIPMENT_CREDIT_BY_ID: `${ADMIN_BASE_URL}/updateExtraFreeShipmentCredit`,
	ADD_EXTRA_FREE_SHIPMENT_CREDIT: `${ADMIN_BASE_URL}/addExtraFreeShipmentCredit`,
	GET_DC_AI_ERROR_LOGS_REPORT: `${ADMIN_BASE_URL}/deliveryCompanyErrorLogs/getDCAIErrorLogsReport`,
	UPDATE_DC_AI_ERROR_LOGS: `${ADMIN_BASE_URL}/deliveryCompanyErrorLogs/updateDCAIErrorLogs`,
	UPDATE_DC_AI_ERROR_EXTRA: `${ADMIN_BASE_URL}/deliveryCompanyErrorLogs/updateDCAIErrorExtra`,
	GET_DC_AI_ERROR: `${ADMIN_BASE_URL}/deliveryCompanyErrorLogs/getDCAIError`,
	GET_SHIPMENT_ERROR_LOGS_BY_AI: `${ADMIN_BASE_URL}/deliveryCompanyErrorLogs/GetShipmentErrorLogsByAi`,
	GET_ANNOUNCEMENT_LIST: `/web/v1/announcement/getAnnouncementList`,
	GET_ANNOUNCEMENT: `/web/v1/announcement/getAnnouncement`,
	ADD_ANNOUNCEMENT: `/web/v1/announcement/addAnnouncement`,
	UPDATE_ANNOUNCEMENT: `/web/v1/announcement/updateAnnouncement`,
	DELETE_ANNOUNCEMENT: `/web/v1/announcement/deleteAnnouncement`,
	GET_ACTIVE_ANNOUNCEMENTS: `/web/v1/announcement/getActiveAnnouncementList`
};

export const CUSTOM_ROLE = {
	GET_ROLE_TEMPLATE_LIST: `${CUSTOM_ROLE_BASE_URL}/getRoleTemplateList`,
	GET_ROLE_TEMPLATE: `${CUSTOM_ROLE_BASE_URL}/getRoleTemplate`,
	ADD_ROLE_TEMPLATE: `${CUSTOM_ROLE_BASE_URL}/addRoleTemplate`,
	UPDATE_ROLE_TEMPLATE: `${CUSTOM_ROLE_BASE_URL}/updateRoleTemplate`,
	DELETE_ROLE_TEMPLATE: `${CUSTOM_ROLE_BASE_URL}/deleteRoleTemplate`,
	GET_CLIENT_ROLE_TREE_LIST: `${CUSTOM_ROLE_BASE_URL}/getClientRoleTreeList`
};

export const AUTH = {
	LOGIN: `${AUTH_BASE_URL}/login`,
	LOGIN_WITH_TOTP: `${AUTH_BASE_URL}/loginWithTOTP`,
	LOGOUT: `${OPEN_BASE_URL}/logout`,
	REFRESH_TOKEN: `${AUTH_BASE_URL}/refreshToken`
};

export const REGISTER = {
	REGISTER_USER: `${REGISTER_BASE_URL}/registerUser`,
	REGISTER_OAUTH: `${REGISTER_BASE_URL}/registerOAuth`,
	CHECK_REGISTER: `${REGISTER_BASE_URL}/checkRegister`
};

export const USERS = {
	GET_USER: `${USER_BASE_URL}/getUser`,
	GET_USER_LIST: `${USER_BASE_URL}/getUserList`,
	ADD_USER: `${USER_BASE_URL}/addUser`,
	UPDATE_USER: `${USER_BASE_URL}/updateUser`,
	UPDATE_USER_STATUS: `${USER_BASE_URL}/updateUserStatus`,
	REQUEST_PASSWORD_RESET: `${USER_BASE_URL}/requestPasswordReset`,
	APPLY_ROLE_TEMPLATE: `${USER_BASE_URL}/applyRoleTemplate`,
	GET_CUSTOM_ROLES: `${USER_BASE_URL}/getCustomRoles`,
	UPDATE_CUSTOM_ROLES: `${USER_BASE_URL}/updateCustomRoles`,
	RESTORE_CUSTOM_ROLES: `${USER_BASE_URL}/restoreCustomRoles`,
	DELETE_ACCOUNT: `${USER_BASE_URL}/deleteAccount`,
	GET_RESET_PASSWORD_LINK: `${USER_BASE_URL}/getResetPasswordLink`,
	// Support endpoints
	CREATE_SUPPORT_ACCESS_LINK: `${USER_BASE_URL}/createSupportAccessLink`,
	APPROVE_SUPPORT_ACCESS: `${USER_BASE_URL}/approveSupportAccess`,
	GET_SUPPORT_ACCESS_LIST: `${USER_BASE_URL}/getSupportAccessList`,
	MOVE_SUPPORT_ACCESS: `${USER_BASE_URL}/moveSupportAccess`,
	GET_CLIENT_USER_LIST: `${USER_BASE_URL}/getClientUserList`,
	ADD_SUPPORT_ACCESS: `${USER_BASE_URL}/addSupportAccess`,
	GET_USER_BY_PHONE: `${USER_BASE_URL}/getUserByPhone`
};

export const COMPANY = {
	GET_REMAINING_AMOUNT: `${COMPANY_BASE_URL}/getRemainingAmount`,
	GET_GENERAL_SETTINGS: `${COMPANY_BASE_URL}/getGeneralSettings`,
	UPDATE_GENERAL_SETTINGS: `${COMPANY_BASE_URL}/updateGeneralSettings`,
	VERIFY_CR_DOCUMENT: `${COMPANY_BASE_URL}/verifyDocument`,
	UPLOAD_DOCUMENTS: `${COMPANY_BASE_URL}/uploadDocument`,
	UPDATE_BANK_ACCOUNT_INFORMATION: `${COMPANY_BASE_URL}/updateBankAccountInformation`,
	UPDATE_CR_DOCUMENT_STATUS: `${COMPANY_BASE_URL}/updateCRDocumentStatus`,
	UPDATE_FL_DOCUMENT_STATUS: `${COMPANY_BASE_URL}/updateFLDocumentStatus`,
	UPDATE_CANCEL_REFUND_STATUS: `${COMPANY_BASE_URL}/updateCancelRefundStatus`,
	GET_PICKUP_LOCATION_COUNTRIES: `${COMPANY_BASE_URL}/getPickupLocationCountries`,
	CHECK_AUTO_VERIFY_ATTEMPT: `${COMPANY_BASE_URL}/checkAutoVerifyAttempt`,
	SET_INVOICE_TYPE: `${COMPANY_BASE_URL}/setInvoiceType`
};
export const REFERRALS = {
	CREATE_REFERRAL_LINK: `${REFERRAL_BASE_URL}/createReferralLink`,
	GET_REFERRALS_LIST: `${REFERRAL_BASE_URL}/getReferralsList`,
	GET_REFERRAL_EARNINGS: `${REFERRAL_BASE_URL}/getReferralEarnings`,
	INVITE_FRIENDS: `${REFERRAL_BASE_URL}/inviteFriends`
};

export const PROFILE = {
	GET_USER_DETAILS: `${PROFILE_BASE_URL}/getUserDetails`,
	UPDATE_USER_DETAILS: `${PROFILE_BASE_URL}/updateUserDetails`,
	VERIFY_MOBILE: `${PROFILE_BASE_URL}/verifyMobileNumber`,
	SEND_VERIFY_CODE: `${PROFILE_BASE_URL}/requestVerification`,
	GET_ROLES: `${PROFILE_BASE_URL}/getRoles`,
	SEND_FCM_TOKEN: `${PROFILE_BASE_URL}/updateFCMToken`,
	UPDATE_PASSWORD: `${PROFILE_BASE_URL}/updatePassword`,
	GET_LOCALIZATION_SETTINGS: `${PROFILE_BASE_URL}/getLocalizationSettings`,
	UPDATE_LOCALIZATION_SETTINGS: `${PROFILE_BASE_URL}/updateLocalizationSettings`,
	GET_COMPANY_MODULES: `${PROFILE_BASE_URL}/getCompanyModules`,
	GET_MODULE_BY_SLUG: `${PROFILE_BASE_URL}/getModuleBySlug`,
	UPDATE_COMPANY_MODULES: `${PROFILE_BASE_URL}/updateCompanyModules`,
	UPDATE_COMPANY_MODULE: `${PROFILE_BASE_URL}/updateCompanyModule`,
	UPDATE_CHAT_RESTORE_ID: `${PROFILE_BASE_URL}/updateChatRestoreId`,
	REQUEST_MAIL_VERIFICATION: `${PROFILE_BASE_URL}/requestMailVerification`,
	VERIFY_MAIL: `${PROFILE_BASE_URL}/verifyMailAddress`,
	VERIFY_MOBILE_OWNERSHIP: `${PROFILE_BASE_URL}/verifyExistingMobileToChange`,
	REQUEST_MOBILE_OWNERSHIP_VERIFICATION: `${PROFILE_BASE_URL}/requestOwnershipVerification`,
	VERIFY_USER: `${USER_IDENTITY}/verifyIdentity`,
	VERIFY_USER_PHONE_ONLY_DEV: `${PROFILE_BASE_URL}/verifyMobileNumberWithoutOTPForDev`
};

export const PAYMENT = {
	GET_PAYTR_TOKEN: `${PAYMENT_BASE_URL}/getPaytrToken`,
	MAKE_CHARGE_PAYTR: `${PAYMENT_BASE_URL}/makeChargePaytr`,
	GET_CARD_DETAILS_PAYTR: `${PAYMENT_BASE_URL}/getCardDetailsPaytr`,
	MAKE_CHARGE: `${PAYMENT_BASE_URL}/makeCharge`,
	MAKE_CHARGE_COD_WALLET: `${PAYMENT_BASE_URL}/makeChargeCODWallet`,
	CHECK_PAYMENT: `${PAYMENT_BASE_URL}/checkPayment`,
	BANK_TRANSFER: `${PAYMENT_BASE_URL}/bankTransfer`,
	CHECK_PROMO_CODE: `${PAYMENT_BASE_URL}/checkPromoCode`,
	GET_SUBSCRIPTION_PACKAGE_DETAILS: `${PAYMENT_BASE_URL}/getSubscriptionPackageDetails`,
	CREATE_SUBSCRIPTION: `${PAYMENT_BASE_URL}/createSubscription`,
	CHECK_SUBSCRIPTION: `${PAYMENT_BASE_URL}/checkSubscription`,
	RETRY_SUBSCRIPTION: `${PAYMENT_BASE_URL}/retrySubscriptionPayment`,
	CHECK_RETRY_SUBSCRIPTION: `${PAYMENT_BASE_URL}/checkRetryPayment`,
	GET_SUBSCRIPTION_PAYMENT_LIST: `${PAYMENT_BASE_URL}/getSubscriptionPaymentList`,
	GET_MANAGE_SUBSCRIPTION: `${PAYMENT_BASE_URL}/getManageSubscription`,
	GET_CLIENT_CARDS_OF_COMPANY: `${PAYMENT_BASE_URL}/getClientCardsOfCompany`,
	ADD_PAYMENT_METHOD: `${PAYMENT_BASE_URL}/addPaymentMethod`,
	CHECK_PAYMENT_METHOD: `${PAYMENT_BASE_URL}/checkAddPaymentMethod`,
	CHANGE_SUBSCRIPTION_CARD: `${PAYMENT_BASE_URL}/changeSubscriptionCard`,
	DELETE_CLIENT_CARD: `${PAYMENT_BASE_URL}/deleteClientCard`,
	GET_DISCOUNTED_AMOUNT_FOR_UPGRADE: `${PAYMENT_BASE_URL}/getDiscountedAmountForUpgrade`,
	GET_RETRY_PAYMENT_AMOUNT: `${PAYMENT_BASE_URL}/getRetryPaymentAmount`,
	CANCEL_PACKAGE_DOWNGRADE: `${PAYMENT_BASE_URL}/cancelPackageDowngrade`,
	CHECK_SUBSCRIPTION_PROMO_CODE: `${PAYMENT_BASE_URL}/checkSubscriptionPromoCode`
};

export const INVOICE = {
	UPDATE_BILLING_INFO: `${INVOICE_BASE_URL}/updateBillingInfo`
};

export const PRINT = {
	GET_PRINT_SETTINGS: `${PRINT_BASE_URL}/getPrintSettings`,
	UPDATE_PRINT_SETTINGS: `${PRINT_BASE_URL}/updatePrintSettings`,
	PRINT_AWB_ACTION: `${PRINT_BASE_URL}/printAWB`,
	GET_ORDER_PRINT_DATA_ACTION: `${PRINT_BASE_URL}/getOrderPrintData`,

	GET_PRINT_SETTINGS_PUBLIC: `${PUBLIC_PRINT_BASE_URL}/getPrintSettings`,
	UPDATE_PRINT_STATUS_PUBLIC: `${PUBLIC_PRINT_BASE_URL}/updateOrderPrintedStatus`,
	PRINT_AWB_ACTION_PUBLIC: `${PUBLIC_PRINT_BASE_URL}/printAWB`,
	GET_ORDER_PRINT_DATA_ACTION_PUBLIC: `${PUBLIC_PRINT_BASE_URL}/getOrderPrintData`,

	GET_PICK_LIST_PDF: `${PRINT_BASE_URL}/getPickListPDF`,
	GET_DC_PICKUP_LIST: `${PRINT_BASE_URL}/getDCPickupList`,
	GET_INTERNATIONAL_PROFORMA: `${PRINT_BASE_URL}/getInternationalProforma`,
	GET_DISPATCHINGING_LIST: `${PRINT_BASE_URL}/getDispatchingList`,
	UPDATE_PRINT_STATUS: `${PRINT_BASE_URL}/updateOrderPrintedStatus`
};

export const EMAIL = {
	GET_EMAIL_ACCOUNT_LIST: `${EMAIL_BASE_URL}/getEmailAccountList`,
	GET_EMAIL_ACCOUNT: `${EMAIL_BASE_URL}/getEmailAccount`,
	ADD_EMAIL_ACCOUNT: `${EMAIL_BASE_URL}/addEmailAccount`,
	UPDATE_EMAIL_ACCOUNT: `${EMAIL_BASE_URL}/updateEmailAccount`,
	GET_EMAIL_SETTING_LIST: `${EMAIL_BASE_URL}/getEmailSettingList`,
	GET_EMAIL_SETTING: `${EMAIL_BASE_URL}/getEmailSetting`,
	ADD_EMAIL_SETTING: `${EMAIL_BASE_URL}/addEmailSetting`,
	UPDATE_EMAIL_SETTING: `${EMAIL_BASE_URL}/updateEmailSetting`,
	TEST_EMAIL_SETTING: `${EMAIL_BASE_URL}/testEmailSetting`,
	SEND_ORDER_EMAIL: `${EMAIL_BASE_URL}/sendOrderEmail`,
	SEND_ORDER_EMAIL_FROM_OPS: `${EMAIL_BASE_URL}/sendOrderEmailFromOperationAccount`
};

export const WHATSAPP = {
	GET_WHATSAPP_SETTING_LIST: `${WHATSAPP_BASE_URL}/settings/getWhatsappSettingListing`,
	GET_WHATSAPP_TEMPLATE_LIST: `${WHATSAPP_BASE_URL}/template/getTemplateListing`,
	ADD_WHATSAPP_SETTING: `${WHATSAPP_BASE_URL}/settings/addWhatsappSetting`,
	UPDATE_WHATSAPP_SETTING: `${WHATSAPP_BASE_URL}/settings/updateWhatsappSetting`,
	GET_WHATSAPP_SETTING: `${WHATSAPP_BASE_URL}/settings/getWhatsappSettingById`,
	ADD_WHATSAPP_TEMPLATE: `${WHATSAPP_BASE_URL}/template/createTemplate`,
	UPDATE_WHATSAPP_TEMPLATE: `${WHATSAPP_BASE_URL}/template/updateTemplate`,
	GET_WHATSAPP_TEMPLATE: `${WHATSAPP_BASE_URL}/template/getTemplateById`,
	GET_TEMPLATES_AUTOCOMPLETE: `${WHATSAPP_BASE_URL}/template/getTemplatesByConnectionID`,

	SEND_WHATSAPP_TEST_MESSAGE: `${WHATSAPP_BASE_URL}/sendTestMessage`,

	TEST_WHATSAPP_CONNECTION: `${WHATSAPP_BASE_URL}/business/testConnection`,
	SAVE_WHATSAPP_INTEGRATION: `${WHATSAPP_BASE_URL}/settings/addWhatsappUser`,
	GET_WHATSAPP_INTEGRATION: `${WHATSAPP_BASE_URL}/settings/getWhatsappUserSettingsByConnectionID`,
	UPDATE_WHATSAPP_INTEGRATION: `${WHATSAPP_BASE_URL}/settings/updateWhatsappUser`,
	SEND_WHATSAPP_MESSAGE: `${WHATSAPP_BASE_URL}/sendWhatsappMessage`
};

export const ADVANCED_OMS = {
	GET_AREA_SETTING_LIST: `${ADVANCED_OMS_BASE_URL}/getAreaSettingList`,
	GET_AREA_SETTING: `${ADVANCED_OMS_BASE_URL}/getAreaSetting`,
	ADD_AREA_SETTING: `${ADVANCED_OMS_BASE_URL}/addAreaSetting`,
	DELETE_AREA_SETTING: `${ADVANCED_OMS_BASE_URL}/deleteAreaSetting`,
	UPDATE_AREA_SETTING: `${ADVANCED_OMS_BASE_URL}/updateAreaSetting`,
	ASSIGN_AREA_TO_DRIVER: `${ADVANCED_OMS_BASE_URL}/assignAreaToDriver`,
	GET_CITY_GROUP_LIST: `${ADVANCED_OMS_BASE_URL}/getCityGroupList`,
	GET_CITY_GROUP: `${ADVANCED_OMS_BASE_URL}/getCityGroup`,
	ADD_CITY_GROUP: `${ADVANCED_OMS_BASE_URL}/addCityGroup`,
	UPDATE_CITY_GROUP: `${ADVANCED_OMS_BASE_URL}/updateCityGroup`,
	DELETE_CITY_GROUP: `${ADVANCED_OMS_BASE_URL}/deleteCityGroup`
};

export const SHIPPING_PRICES = {
	GET_SHIPPING_PRICE_LIST: `${PRICE_CALCULATOR_BASE_URL}/getOtoDeliveryPriceListForCompany`,
	GET_SHIPPING_PRICE: `${PRICE_CALCULATOR_BASE_URL}/getOtoDeliveryPriceForCompany`,
	ADD_SHIPPING_PRICE: `${PRICE_CALCULATOR_BASE_URL}/addOtoDeliveryPriceForCompany`,
	DELETE_SHIPPING_PRICE: `${PRICE_CALCULATOR_BASE_URL}/deleteOtoDeliveryPrice`,

	GET_SHIPPING_PRICE_SPECIAL_SETTINGS_LIST: `${PRICE_CALCULATOR_BASE_URL}/getSpecialContractTermListByCompany`,
	GET_SHIPPING_PRICE_SPECIAL_SETTING: `${PRICE_CALCULATOR_BASE_URL}/getSpecialContractTerm`,
	ADD_SHIPPING_PRICE_SPECIAL_SETTING: `${PRICE_CALCULATOR_BASE_URL}/addSpecialContractTermForCompany`,
	DELETE_SHIPPING_PRICE_SPECIAL_SETTING: `${PRICE_CALCULATOR_BASE_URL}/deleteSpecialContractTerm`,

	GET_SHIPPING_PRICE_TRANSACTION_LIST: `${ACCOUNTING_BASE_URL}/getShippingPriceTransactionsList`,

	GET_INVOICE_CHECKER_HISTORY_LIST: `${ACCOUNTING_BASE_URL}/getInvoiceCheckerHistoryList`,
	UPDATE_INVOICE_IS_READ: `${ACCOUNTING_BASE_URL}/updateInvoiceIsRead`,

	// AutoCompletes
	GET_DC_AUTOCOMPLETE: `${PRICE_CALCULATOR_BASE_URL}/getDeliveryCompanySettingsAutoComplete`,

	// Invoice
	GET_INVOICE_TRANSACTIONS_LIST: `${ACCOUNTING_BASE_URL}/getInvoiceTransactionsList`,
	GET_INVOICE_TRANSACTION_RECORD: `${ACCOUNTING_BASE_URL}/getInvoiceTransactionRecord`,
	ADD_INVOICE_TRANSACTION_RECORD: `${ACCOUNTING_BASE_URL}/addInvoiceTransactionRecord`,
	DELETE_INVOICE_TRANSACTION: `${ACCOUNTING_BASE_URL}/deleteInvoiceTransaction`,

	GET_INVOICE_DETAILS_LIST: `${ACCOUNTING_BASE_URL}/getInvoiceDetailsList`,
	GET_INVOICE_DETAIL_INFO: `${ACCOUNTING_BASE_URL}/getInvoiceDetailInfo`,
	GET_INVOICES_LIST: `${ACCOUNTING_BASE_URL}/getInvoicesList`,
	GET_INVOICE_INFO_TO_BE_CREATED: `${ACCOUNTING_BASE_URL}/getInvoiceInfoToBeCreated`,
	CREATE_INVOICE: `${ACCOUNTING_BASE_URL}/createInvoice`,
	DELETE_INVOICE: `${ACCOUNTING_BASE_URL}/deleteInvoice`,
	GET_INVOICE_INFO_TO_BE_DELETED: `${ACCOUNTING_BASE_URL}/getInvoiceInfoToBeDeleted`,
	SEND_INVOICE_TO_WAITING_APPROVAL: `${ACCOUNTING_BASE_URL}/sendInvoiceToWaitingForApproval`,
	SEND_INVOICE_BACK_TO_DRAFT: `${ACCOUNTING_BASE_URL}/sendInvoiceBackToDraft`,
	SEND_INVOICE_TO_APPROVED: `${ACCOUNTING_BASE_URL}/sendInvoiceToApproved`,
	GET_NOT_INVOICED_ORDERS_LIST: `${ACCOUNTING_BASE_URL}/getNotInvoicedOrdersList`,
	SEND_NOT_INVOICED_ORDERS_TO_KAFKA: `${ACCOUNTING_BASE_URL}/sendNotInvoicedOrdersToKafka`
};

export const BOXES = {
	GET_BOX_LIST: `${BOX_BASE_URL}/getBoxList`,
	GET_BOX: `${BOX_BASE_URL}/getBox`,
	ADD_BOX: `${BOX_BASE_URL}/addBox`,
	UPDATE_BOX: `${BOX_BASE_URL}/updateBox`,
	DELETE_BOX: `${BOX_BASE_URL}/deleteBox`,
	GET_DEFAULT_BOX: `${BOX_BASE_URL}/getDefaultBox`
};

export const RETURNS = {
	GET_RETURNS_LIST: `${RMS_BASE_URL}/getReturnList`,
	RETURN_STATUS_CHANGE: `${RMS_BASE_URL}/returnsStatusChange`
};

export const CUSTOMER_SERVICE = {
	GET_FAILED_DELIVERY_ORDERS: `${CUSTOMER_SERVICE_BASE_URL}/getFailedDeliveryOrders`,
	GET_CUSTOMER_FEEDBACKS: `${CUSTOMER_SERVICE_BASE_URL}/getCustomerFeedbackList`,
	GET_PROCESSING_ORDERS: `${CUSTOMER_SERVICE_BASE_URL}/getProcessingOrders`,
	GET_HISTORY_ORDERS: `${CUSTOMER_SERVICE_BASE_URL}/getHistoryOrdersList`
};

export const IMPORT_EXPORT = {
	GET_PRODUCT_TEMPLATE: `${IMPORT_BASE_URL}/getProductTemplate`,
	GET_ORDER_TEMPLATE: `${IMPORT_BASE_URL}/getOrderTemplate`,
	GET_INVENTORY_TEMPLATE: `${IMPORT_BASE_URL}/getInventoryTemplate`,
	GET_BIN_INVENTORY_TEMPLATE: `${IMPORT_BASE_URL}/getBinInventoryTemplate`,
	GET_BIN_TEMPLATE: `${IMPORT_BASE_URL}/getBinTemplate`,
	GET_ZONE_TEMPLATE: `${IMPORT_BASE_URL}/getZoneTemplate`,
	GET_USER_TEMPLATE: `${IMPORT_BASE_URL}/getUserTemplate`,
	GET_CUSTOMER_LIST_TEMPLATE: `${IMPORT_BASE_URL}/getCustomerListTemplate`,
	GET_DRIVER_TEMPLATE: `${IMPORT_BASE_URL}/getDriverTemplate`,
	GET_INVOICE_TEMPLATE: `${IMPORT_BASE_URL}/getInvoiceTemplate`,
	GET_WAREHOUSE_TEMPLATE: `${IMPORT_BASE_URL}/getWarehouseTemplate`,
	GET_SHIPPING_DESCRIPTION_TEMPLATE: `${IMPORT_BASE_URL}/getShippingDescriptionTemplate`,
	GET_BRANCH_TEMPLATE: `${IMPORT_BASE_URL}/getBranchTemplate`,
	GET_IMPORT_LOG_LIST: `${IMPORT_BASE_URL}/getImportLogList`,
	GET_COUNTRY_TEMPLATE: `${IMPORT_BASE_URL}/getCountryTemplate`,
	GET_STATE_TEMPLATE: `${IMPORT_BASE_URL}/getStateTemplate`,
	GET_CITY_TEMPLATE: `${IMPORT_BASE_URL}/getCityTemplate`,
	GET_DISTRICT_TEMPLATE: `${IMPORT_BASE_URL}/getDistrictTemplate`,
	GET_NEIGHBORHOOD_TEMPLATE: `${IMPORT_BASE_URL}/getNeighbourhoodTemplate`,
	GET_RECEIVABLE_REPORTS_TEMPLATE: `${IMPORT_BASE_URL}/getReceivableReportsTemplate`,
	GET_DC_PICKUP_LOCATION_TEMPLATE: `${IMPORT_BASE_URL}/getDCPickupLocationTemplate`,
	IMPORT_PRODUCT: `${IMPORT_BASE_URL}/importProduct`,
	IMPORT_ORDER: `${IMPORT_BASE_URL}/importOrder`,
	IMPORT_WAREHOUSE: `${IMPORT_BASE_URL}/importWarehouse`,
	IMPORT_BRANCH: `${IMPORT_BASE_URL}/importBranch`,
	IMPORT_USER: `${IMPORT_BASE_URL}/importUser`,
	IMPORT_CUSTOMER_LIST: `${IMPORT_BASE_URL}/importCustomerList`,
	IMPORT_INVENTORY: `${IMPORT_BASE_URL}/importInventory`,
	IMPORT_BIN_INVENTORY: `${IMPORT_BASE_URL}/importBinInventory`,
	IMPORT_BIN: `${IMPORT_BASE_URL}/importBin`,
	IMPORT_ZONE: `${IMPORT_BASE_URL}/importZone`,
	IMPORT_DRIVER: `${IMPORT_BASE_URL}/importDriver`,
	IMPORT_INVOICE: `${IMPORT_BASE_URL}/importInvoice`,
	IMPORT_COUNTRY: `${IMPORT_BASE_URL}/importCountry`,
	IMPORT_STATE: `${IMPORT_BASE_URL}/importState`,
	IMPORT_CITY: `${IMPORT_BASE_URL}/importCity`,
	IMPORT_DISTRICT: `${IMPORT_BASE_URL}/importDistrict`,
	IMPORT_NEIGHBORHOOD: `${IMPORT_BASE_URL}/importNeighbourhood`,
	IMPORT_SHIPPING_DESCRIPTION: `${IMPORT_BASE_URL}/importShippingDescription`,
	IMPORT_RECEIVABLE_REPORTS: `${IMPORT_BASE_URL}/importReceivableReports`,
	IMPORT_SALLA_ORDERS: `${IMPORT_BASE_URL}/importSallaOrder`,
	IMPORT_KSA_ORDERS: `${IMPORT_BASE_URL}/importKSAOrder`,
	EXPORT_PICK_LIST_EXCEL: `${EXPORT_BASE_URL}/pickListExcel`,
	GET_GOVERNORATE_TEMPLATE: `${IMPORT_BASE_URL}/getGovernorateTemplate`,
	IMPORT_GOVERNORATE: `${IMPORT_BASE_URL}/importGovernorate`,
	IMPORT_DC_PICKUP_LOCATION: `${IMPORT_BASE_URL}/importDCPickupLocation`
};

export const FORM_IMPORT = {
	GET_FORM_IMPORT_PRODUCT_TEMPLATE: `${FORM_IMPORT_BASE_URL}/getFormImportProductTemplate`,
	IMPORT_PRODUCT_TEMPLATE: `${FORM_IMPORT_BASE_URL}/product`
};

export const ONBOARDING = {
	GET_ONBOARDING: `${ONBOARDING_BASE_URL}/getOnboarding`,
	UPDATE_ONBOARDING: `${ONBOARDING_BASE_URL}/updateOnboarding`,
	GET_VIDEO_REWARD: `${ONBOARDING_BASE_URL}/getVideoRewardAmount`,
	COMPLETE_VIDEO_REWARD: `${ONBOARDING_BASE_URL}/completeVideoReward`
};

export const REASONCONFIG = {
	GET_REASON_CONFIG_LIST: `${REASON_CONFIG_BASE_URL}/getReasonConfigList`,
	GET_REASON_CONFIG: `${REASON_CONFIG_BASE_URL}/getReasonConfig`,
	ADD_REASON_CONFIG: `${REASON_CONFIG_BASE_URL}/addReasonConfig`,
	UPDATE_REASON_CONFIG: `${REASON_CONFIG_BASE_URL}/updateReasonConfig`,

	GET_PREDEFINED_MESSAGE_LIST: `${REASON_CONFIG_BASE_URL}/getPredefinedMessageList`,
	GET_PREDEFINED_MESSAGE: `${REASON_CONFIG_BASE_URL}/getPredefinedMessage`,
	ADD_PREDEFINED_MESSAGE: `${REASON_CONFIG_BASE_URL}/addPredefinedMessage`,
	UPDATE_PREDEFINED_MESSAGE: `${REASON_CONFIG_BASE_URL}/updatePredefinedMessage`
};

export const BLACKLISTED_CUSTOMER = {
	GET_BLACKLISTED_CUSTOMER_LIST: `${ADVANCED_OMS_BASE_URL}/getBlacklistedCustomerList`,
	GET_BLACKLISTED_CUSTOMER: `${ADVANCED_OMS_BASE_URL}/getBlacklistedCustomer`,
	ADD_BLACKLISTED_CUSTOMER: `${ADVANCED_OMS_BASE_URL}/addBlacklistedCustomer`,
	UPDATE_BLACKLISTED_CUSTOMER: `${ADVANCED_OMS_BASE_URL}/updateBlacklistedCustomer`,
	DELETE_BLACKLISTED_CUSTOMER: `${ADVANCED_OMS_BASE_URL}/deleteBlacklistedCustomer`
};

export const WAREHOUSES_USERS = {
	GET_PENDING_ORDERS: `${WHUSER_BASE_URL}/getWHPendingOrdersList`,
	GET_WAITING_PICKUP: `${WHUSER_BASE_URL}/getWHWaitingPickupList`,
	GET_SHIPMENT_IN_PROGRESS: `${WHUSER_BASE_URL}/getWHShipmentInProgressList`,
	GET_HISTORY: `${WHUSER_BASE_URL}/getWHHistoryList`,
	GET_SHIPMENT_ON_HOLD: `${WHUSER_BASE_URL}/getWHShipmentOnHoldList`,
	GET_WAREHOUSE_TODAYS_ACTIVITY: `${WHUSER_BASE_URL}/getWarehouseTodaysActivity`,
	GET_WAREHOUSE_WAITING_PICKUP_BYDC: `${WHUSER_BASE_URL}/getWarehouseWaitingPickupByDC`,
	GET_WAREHOUSE_PERFORMANCE: `${WHUSER_BASE_URL}/getWarehousePerformance`,
	GET_ASSIGNED_WAREHOUSES: `${WHUSER_BASE_URL}/getAssignedWarehouses`
};

export const BRANCH_USERS = {
	GET_PENDING_ORDER_LIST: `${BRUSER_BASE_URL}/getBRPendingOrderList`,
	GET_WAITING_PICKUP: `${BRUSER_BASE_URL}/getBRWaitingPickupList`,
	GET_SHIPMENT_IN_PROGRESS: `${BRUSER_BASE_URL}/getBRShipmentInProgressList`,
	GET_DELIVERED_ORDER_LIST: `${BRUSER_BASE_URL}/getBRDeliveredList`,
	GET_RETURNED_ORDER_LIST: `${BRUSER_BASE_URL}/getBRReturnedList`,
	GET_CANCELED_ORDER_LIST: `${BRUSER_BASE_URL}/getBRCanceledList`,
	GET_UNASSINGED_ORDER_LIST: `${BRUSER_BASE_URL}/getBRUnassignedOrderList`,
	GET_BRANCH_TODAYS_ACTIVITY: `${BRUSER_BASE_URL}/getBranchTodaysActivity`,
	GET_BRANCH_WAITING_PICKUP_BYDC: `${BRUSER_BASE_URL}/getBranchWaitingPickupByDC`,
	GET_BRANCH_PERFORMANCE: `${BRUSER_BASE_URL}/getBranchPerformance`
};

export const SHIPPING_AUTOMATION = {
	GET_PRIORITY_RULE_LIST: `${SHIPPING_AUTOMATION_BASE_URL}/getPriorityRuleList`,
	GET_PRIORITY_RULE: `${SHIPPING_AUTOMATION_BASE_URL}/getPriorityRule`,
	ADD_PRIORITY_RULE: `${SHIPPING_AUTOMATION_BASE_URL}/addPriorityRule`,
	UPDATE_PRIORITY_RULE: `${SHIPPING_AUTOMATION_BASE_URL}/updatePriorityRule`,
	DELETE_PRIORITY_RULE: `${SHIPPING_AUTOMATION_BASE_URL}/deletePriorityRule`,
	UPDATE_PRIORITY_RULE_STATUS: `${SHIPPING_AUTOMATION_BASE_URL}/updatePriorityRuleStatus`,
	GET_FEASIBILITY_RULE_LIST: `${SHIPPING_AUTOMATION_BASE_URL}/getFeasibilityRuleList`,
	GET_FEASIBILITY_RULE_DCS_BY_RULEID: `${SHIPPING_AUTOMATION_BASE_URL}/getFeasibilityDeliveryCompaniesByRuleID`,
	GET_FEASIBILITY_RULE: `${SHIPPING_AUTOMATION_BASE_URL}/getFeasibilityRule`,
	ADD_FEASIBILITY_RULE: `${SHIPPING_AUTOMATION_BASE_URL}/addFeasibilityRule`,
	UPDATE_FEASIBILITY_RULE: `${SHIPPING_AUTOMATION_BASE_URL}/updateFeasibilityRule`,
	DELETE_FEASIBILITY_RULE: `${SHIPPING_AUTOMATION_BASE_URL}/deleteFeasibilityRule`,
	DELETE_FEASIBILITY_RULE_ITEM: `${SHIPPING_AUTOMATION_BASE_URL}/deleteFeasibilityRuleParameter`,
	UPDATE_FEASIBILITY_RULE_STATUS: `${SHIPPING_AUTOMATION_BASE_URL}/updateFeasibilityRuleStatus`,
	FEASIBILITY_TEST: `${SHIPPING_AUTOMATION_BASE_URL}/feasibilityTest`,
	RUN_FEASIBILITY_RULE_TEST: `${SHIPPING_AUTOMATION_BASE_URL}/checkFeasibilityRules`,
	GET_AUTOMATION_TEST_RESULT: `${SHIPPING_AUTOMATION_BASE_URL}/getAutomationTestResult`,
	UPDATE_AUTOMATION_SETTINGS: `${SHIPPING_AUTOMATION_BASE_URL}/updateAutomationSettings`
};

export const ORDER_AUTOMATION = {
	GET_ORDER_AUTOMATION_LIST: `${ADVANCED_OMS_BASE_URL}/getOrderAutomationRuleList`,
	GET_ORDER_AUTOMATION: `${ADVANCED_OMS_BASE_URL}/getOrderAutomationRule`,
	ADD_ORDER_AUTOMATION: `${ADVANCED_OMS_BASE_URL}/addOrderAutomationRule`,
	UPDATE_ORDER_AUTOMATION: `${ADVANCED_OMS_BASE_URL}/updateOrderAutomationRule`,
	DELETE_ORDER_AUTOMATION: `${ADVANCED_OMS_BASE_URL}/deleteOrderAutomationRule`,
	UPDATE_ORDER_AUTOMATION_STATUS: `${ADVANCED_OMS_BASE_URL}/updateOrderAutomationRuleStatus`,
	GET_ORDER_AUTOMATION_TEST_RESULT: `${ADVANCED_OMS_BASE_URL}/getOrderAutomationTestResult`,
	UPDATE_ORDER_AUTOMATION_ORDERS: `${ADVANCED_OMS_BASE_URL}/updateOrderAutomationOrders`,
	GET_ORDER_AUTOMATION_ORDERS: `${ADVANCED_OMS_BASE_URL}/getOrderAutomationOrders`
};

export const BRANCHES = {
	GET_BRANCH_LIST: `${BRANCHES_BASE_URL}/getBranchList`,
	GET_BRANCH: `${BRANCHES_BASE_URL}/getBranch`,
	ADD_BRANCH: `${BRANCHES_BASE_URL}/addBranch`,
	UPDATE_BRANCH: `${BRANCHES_BASE_URL}/updateBranch`,
	UPDATE_BRANCH_STATUS: `${BRANCHES_BASE_URL}/updateBranchStatus`,
	UPDATE_BRANCH_RADIUS: `${BRANCHES_BASE_URL}/updateRadiusForBranches`
};

export const REPORT = {
	DASHBOARD: {
		GET_DASHBOARD_SHIPMENT_NUMBERS: `${REPORT_DASHBOARD_BASE_URL}/getDashboardShipmentsNumbers`,
		GET_SALES_CHANNEL_DISTRIBUTION: `${REPORT_DASHBOARD_BASE_URL}/getSalesChannelDistribution `,
		GET_SHIPPING_PARTNERS_DISTRIBUTION: `${REPORT_DASHBOARD_BASE_URL}/getShippingPartnersDistribution`,
		GET_TOP_DESTINATION_POINTS: `${REPORT_DASHBOARD_BASE_URL}/getTopDestinationPoints`,
		GET_DASHBOARD_WAREHOUSE_BRANCH_ORDERS: `${REPORT_DASHBOARD_BASE_URL}/getDashboardWarehouseBranchOrders`,
		GET_DASHBOARD_WAREHOUSE_ORDERS: `${REPORT_DASHBOARD_BASE_URL}/getDashboardWarehouseOrders`,
		GET_DASHBOARD_BRANCH_ORDERS: `${REPORT_DASHBOARD_BASE_URL}/getDashboardBranchOrders`,
		GET_DASHBOARD_OVERVIEW: `${REPORT_DASHBOARD_BASE_URL}/getDashboardOverview`,
		GET_DASHBOARD_OVERVIEW_DAILY: `${REPORT_DASHBOARD_BASE_URL}/getDashboardOverviewDaily`,
		GET_DASHBOARD_OVERVIEW_HOURLY: `${REPORT_DASHBOARD_BASE_URL}/getDashboardOverviewHourly`,
		GET_DASHBOARD_COD_SUMMARY: `${REPORT_DASHBOARD_BASE_URL}/getDashboardCODSummary`,
		GET_DASHBOARD_SHIPMENT_NEED_ACTION: `${REPORT_DASHBOARD_BASE_URL}/getDashboardShipmentNeedAction`
	},
	LIST: {
		GET_EXPORT_LOG_LIST: `${REPORT_LIST_BASE_URL}/getExportLogList`,
		GET_DRIVER_SUMMARY_LIST: `${REPORT_LIST_BASE_URL}/getDriverSummaryList`,
		GET_DRIVER_DETAILS_LIST: `${REPORT_LIST_BASE_URL}/getDriverDetailList`,
		GET_ORDER_STATUS_LOG_LIST: `${REPORT_LIST_BASE_URL}/getOrderStatusLogList`,
		GET_PAID_COD_LIST: `${REPORT_LIST_BASE_URL}/getPaidCODList`,
		GET_DAILY_ORDER_STATS_LIST: `${REPORT_LIST_BASE_URL}/getDailyOrderStatsList`,
		GET_TIME_STAT_LIST: `${REPORT_LIST_BASE_URL}/getTimeStatList`,
		GET_CUSTOMER_FEEDBACKS_LIST: `${REPORT_LIST_BASE_URL}/getCustomerFeedbackList`,
		GET_SLA_BREACHES_LIST: `${REPORT_LIST_BASE_URL}/getSLABreachesList`,
		GET_SALES_BY_SKU_LIST: `${REPORT_LIST_BASE_URL}/getSalesBySKUList`,
		GET_ORDERS_BY_PRODUCT_LIST: `${REPORT_LIST_BASE_URL}/getOrdersByProductList`,
		GET_AGED_ORDERS_LIST: `${REPORT_LIST_BASE_URL}/getAgedOrdersList`,
		GET_RESENT_ORDERS_LIST: `${REPORT_LIST_BASE_URL}/getResentOrdersList`,
		GET_DELIVERY_COMPANY_BY_CITY_LIST: `${REPORT_LIST_BASE_URL}/getDeliveryCompanyByCityList`,
		GET_SHIPMENT_STATUS_LIST: `${REPORT_LIST_BASE_URL}/getShipmentStatusList`,
		GET_OTO_FLEX_TRANSACTION_LIST: `${REPORT_LIST_BASE_URL}/getOTOFlexTransactionList`,
		GET_BRANCH_REPORT_LIST: `${REPORT_LIST_BASE_URL}/getBranchReportList`,
		GET_BRANCH_DAILY_STAFF_REPORT_LIST: `${REPORT_LIST_BASE_URL}/getBranchStaffReport`,
		GET_PICKUP_AND_DELIVERY_LIST: `${REPORT_LIST_BASE_URL}/getPickupAndDeliveryList`,
		GET_PICKUP_AND_DELIVERY_LIST_OPERATIONS: `${REPORT_LIST_BASE_URL}/getPickupDeliveryOperationsList`,
		GET_FAILED_DELIVERY_LIST: `${REPORT_LIST_BASE_URL}/getFailedDeliveryList`,
		GET_DELIVERED_ORDERS_BY_CITY_BY_COURIER_LIST: `${REPORT_LIST_BASE_URL}/getDeliveredOrdersByCityByCourierList`,
		GET_CUSTOM_REPORT_1_LIST: `${REPORT_LIST_BASE_URL}/getCustomReport1`,
		GET_DELIVERY_ATTEMPT_REPORT_LIST: `${REPORT_LIST_BASE_URL}/getDeliveryAttemptReport`,
		GET_AGGREGATOR_PROFIT_REPORT_LIST: `${REPORT_LIST_BASE_URL}/getAggregatorOTOProfitReportList`,

		// ACTIONS
		GET_PAID_COD_DETAIL: `${REPORT_LIST_BASE_URL}/getPaidCODDetail`,
		GET_PAID_COD_DETAIL_LIST: `${REPORT_LIST_BASE_URL}/getPaidCODDetailList`,

		// OPERATION
		GET_TIME_STAT_FOR_OPERATION_LIST: `${REPORT_LIST_BASE_URL}/getTimeStatReportList`,
		GET_ADMIN_DELIVERY_ATTEMPT_REPORT_LIST: `${REPORT_LIST_BASE_URL}/getDeliveryAttemptReportList`
	},
	ANALYSIS: {
		GET_CURRENT_PREPARATION_ORDERS: `${REPORT_ANALYSIS_BASE_URL}/getPendingPreparationOrders`,
		GET_CURRENT_PICKUP_ORDERS: `${REPORT_ANALYSIS_BASE_URL}/getPendingPickupOrders`,
		GET_CURRENT_DELIVERY_ORDERS: `${REPORT_ANALYSIS_BASE_URL}/getPendingDeliveryOrders`,
		GET_LATE_PREPARATIONS_ORDERS: `${REPORT_ANALYSIS_BASE_URL}/getLatePreparationOrders`,
		GET_LATE_PICKUP_ORDERS: `${REPORT_ANALYSIS_BASE_URL}/getLatePickupOrders`,
		GET_LATE_DELIVERY_ORDERS: `${REPORT_ANALYSIS_BASE_URL}/getLateDeliveryOrders`,
		GET_DELIVERED_PAYMENT_METHOD: `${REPORT_ANALYSIS_BASE_URL}/getDeliveredPaymentMethod`,
		GET_DELIVERY_COMPANY_DISTRIBUTION: `${REPORT_ANALYSIS_BASE_URL}/getDeliveryCompanyDistribution`,
		GET_CLOSED_ORDERS: `${REPORT_ANALYSIS_BASE_URL}/getClosedOrders`,
		GET_PROCESSING_ORDERS: `${REPORT_ANALYSIS_BASE_URL}/getProcessingOrders`,
		GET_PAYMENT_METHOD: `${REPORT_ANALYSIS_BASE_URL}/getPaymentMethodAnalysis`,
		GET_ASSIGNED_WHS_VS_FULLFILL: `${REPORT_ANALYSIS_BASE_URL}/getAssignedToWHVsFulfillAnalysis`
	},
	SLA: {
		GET_SLA_PERFORMANCE: `${REPORT_SLA_BASE_URL}/getSLAPerformance`,
		GET_PREPARATION_SLA: `${REPORT_SLA_BASE_URL}/getPreparationSLAPerformance`,
		GET_PICKUP_SLA: `${REPORT_SLA_BASE_URL}/getPickupSLAPerformance`,
		GET_DELIVERY_SLA: `${REPORT_SLA_BASE_URL}/getDeliverySLAPerformance`,
		GET_INTEGRATOR_SLA_REPORT_LIST: `${REPORT_SLA_BASE_URL}/getShipmentSLAPerformance`,
		UPDATE_SLA_BREACH_ON_SHIPMENT_STATUS_LIST: `${REPORT_SLA_BASE_URL}/updateSLABreachOnShipmentStatusList`
	},
	SALES: {
		GET_TODAY_ACTIVITY: `${REPORT_SALES_BASE_URL}/getTodaysActivity`,
		GET_TOP_5_CITIES: `${REPORT_SALES_BASE_URL}/getTop5CitiesPieChart`,
		GET_FREE_VS_PAID_SHIPPING: `${REPORT_SALES_BASE_URL}/getFreeVsPaidShippingPieChart`,
		GET_TOP_10_SELLING_SKUS: `${REPORT_SALES_BASE_URL}/getTop10SellingSKUs`,
		GET_AVG_BASKET_SIZE: `${REPORT_SALES_BASE_URL}/getAverageBasketSizeMoMBarChart`,
		GET_NUMBER_OF_ORDERS: `${REPORT_SALES_BASE_URL}/getOrderNumberLineChart`
	},
	DELIVERY_COMPANY: {
		GET_DC_PERFORMANCE: `${REPORT_DELIVERY_COMPANY_BASE_URL}/getDeliveryCompanyPerformanceList`,
		GET_DC_DELAYS: `${REPORT_DELIVERY_COMPANY_BASE_URL}/getCarrierDelayNumbersList`,
		GET_COD_COLLECTED: `${REPORT_DELIVERY_COMPANY_BASE_URL}/getCODCollectedAnalysis`,
		GET_TOTAL_SHIPPING_COST: `${REPORT_DELIVERY_COMPANY_BASE_URL}/getTotalShippingCostAnalysis`,
		GET_RETURN_FEE_SPENT: `${REPORT_DELIVERY_COMPANY_BASE_URL}/getReturnFeeSpentAnalysis`,
		GET_AVG_SHIPPING_COST: `${REPORT_DELIVERY_COMPANY_BASE_URL}/getAvgShippingCostAnalysis`,
		GET_AGGREGATOR_AGING_LIST: `${REPORT_DELIVERY_COMPANY_BASE_URL}/getAggregatorAgingList`,
		GET_AGGREGATOR_AGING_ANALYSIS: `${REPORT_DELIVERY_COMPANY_BASE_URL}/getAgingAnalysis`,
		GET_AGGREGATOR_AGING_DC_ANALYSIS: `${REPORT_DELIVERY_COMPANY_BASE_URL}/getAgingDeliveryCompanyAnalysis`,
		GET_AGGREGATOR_AGING_WEEKLY_ANALYSIS: `${REPORT_DELIVERY_COMPANY_BASE_URL}/getAgingWeeklyAnalysis`,
		GET_OTO_SHIPPING_PARTNER_FEES: `${REPORT_DELIVERY_COMPANY_BASE_URL}/getOTOShippingPartnersFees`,
		GET_TOTAL_ANALYSIS: `${REPORT_DELIVERY_COMPANY_BASE_URL}/getTotalAnalysis`,
		GET_AGGREGATOR_AGING_LIST_CLIENT: `${REPORT_DELIVERY_COMPANY_BASE_URL}/getAggregatorAgingListClient`,
		GET_AGGREGATOR_AGING_ANALYSIS_CLIENT: `${REPORT_DELIVERY_COMPANY_BASE_URL}/getAgingAnalysisClient`,
		GET_AGGREGATOR_AGING_DC_ANALYSIS_CLIENT: `${REPORT_DELIVERY_COMPANY_BASE_URL}/getAgingDeliveryCompanyAnalysisClient`
	},
	OTO_FLEX: {
		GET_ALL_ORDERS_SUMMARY: `${REPORT_OTO_FLEX_BASE_URL}/getAllOrdersSummary`,
		GET_NUMBER_OF_ORDERS_OTOFLEX: `${REPORT_OTO_FLEX_BASE_URL}/getNumberOfOrdersOTOFlex`,
		GET_DRIVER_PERFORMANCE: `${REPORT_OTO_FLEX_BASE_URL}/getDriverPerformanceList`
	},
	OTO_PACK: {
		GET_INBOUND_STATISTIC: `${REPORT_OTO_PACK_BASE_URL}/getInboundStatistics`,
		GET_PICK_STATISTIC: `${REPORT_OTO_PACK_BASE_URL}/getPickStatistics`,
		GET_PACK_STATISTIC: `${REPORT_OTO_PACK_BASE_URL}/getPackStatistics`,
		GET_RETURN_STATISTIC: `${REPORT_OTO_PACK_BASE_URL}/getReturnStatistics`,
		GET_PACKING_STATUS_REPORTS: `${REPORT_OTO_PACK_BASE_URL}/getPackingStatusHistory`
	},

	CUSTOMER_DETAILS: {
		GET_CUSTOMER_ACTIVITY: `${REPORT_CUSTOMER_DETAILS_BASE_URL}/getCustomerActivity`,
		GET_CUSTOMER_ACTIVITY_COD: `${REPORT_CUSTOMER_DETAILS_BASE_URL}/getCustomerActivityCOD`,
		GET_LAST_10_ORDER: `${REPORT_CUSTOMER_DETAILS_BASE_URL}/getLast10OrdersList`,
		GET_LAST_10_ORDER_BY_STATUS: `${REPORT_CUSTOMER_DETAILS_BASE_URL}/getLast10OrdersByStatusList`,
		GET_LAST_10_DELIVERED_ORDER: `${REPORT_CUSTOMER_DETAILS_BASE_URL}/getLast10DeliveredOrdersList`,
		GET_LAST_10_RETURNED_ORDER: `${REPORT_CUSTOMER_DETAILS_BASE_URL}/getLast10ReturnedOrdersList`,
		GET_LAST_10_COD_ORDER: `${REPORT_CUSTOMER_DETAILS_BASE_URL}/getLast10CODOrderList`
	},
	OTO: {
		GET_COMPARED_ORDER_WEEKLY: `${REPORT_OTO_BASE_URL}/getComparedOrderCountWeekly`,
		COMPANY_KPI_DASHBOARD_WEEKLY: `${REPORT_OTO_BASE_URL}/getCompanyKpiDashboardWeekly`
	},
	DC: {
		GET_DC_SCORE_LIST: `${REPORT_DC_BASE_URL}/getDeliveryCompanyScoreList`,
		GET_DC_SCORE_OVERVIEW: `${REPORT_DC_BASE_URL}/getDeliveryCompanyScoreOverview`,
		GET_ZERO_DC_DETAILED_LIST: `${PRICE_CALCULATOR_BASE_URL}/getZeroResultLogList`,
		GET_ZERO_DC_GROUPED_LIST: `${PRICE_CALCULATOR_BASE_URL}/getZeroResultGrouped`,
		UPDATE_ZERO_DC_RESULT_LOG: `${PRICE_CALCULATOR_BASE_URL}/updateZeroDcResultLog`
	},
	SHIPPING_ACCOUNTING: {
		GET_INTEGRATOR_DELIVERY_FEES: `${REPORT_DC_BASE_URL}/getIntegratorDeliveryFees`,
		GET_OTO_SHIPPING_PARTNERS_FEES: `${REPORT_DC_BASE_URL}/getOTOShippingPartnersFees`,
		GET_SAAS_FEES: `${REPORT_DC_BASE_URL}/getSAASFees`
	}
};

export const LOGS = {
	GET_UPDATE_LOGS_LIST: `${LOGS_BASE_URL}/getUpdateLogsList`,
	GET_SMS_LOGS_LIST: `${LOGS_BASE_URL}/getSMSLogsList`,
	GET_EMAIL_LOGS_LIST: `${LOGS_BASE_URL}/getMailLogsList`,
	GET_SHIPMENT_ERROR_LOGS_LIST: `${LOGS_BASE_URL}/getShipmentErrorLogsList`,
	GET_ECOMMERCE_ERROR_LOGS_LIST: `${LOGS_BASE_URL}/getEcommerceErrorLogsList`,
	GET_WEBHOOK_ERROR_LOGS_LIST: `${LOGS_BASE_URL}/getWebhookErrorLogsList`,
	GET_INVENTORY_SYNC_LOGS_LIST: `${LOGS_BASE_URL}/getInventorySyncLogsList`,
	GET_PRODUCT_SYNC_LOGS_LIST: `${LOGS_BASE_URL}/getProductSyncLogsList`,
	GET_AUTOMATION_SUCCESS_LOGS_LIST: `${LOGS_BASE_URL}/getAutomationSuccessLogsList`,
	GET_AUTOMATION_ERROR_LOGS_LIST: `${LOGS_BASE_URL}/getAutomationFailedLogsList`,
	GET_PICKUP_REQUEST_LIST: `${LOGS_BASE_URL}/getPickupLogList`
};

export const CREDIT = {
	GET_OTO_CREDIT_LIST: `${CREDIT_BASE_URL}/getOTOCreditList`,
	GET_CREDIT_TRANSACTION_LIST: `${CREDIT_BASE_URL}/getCreditTransactionList`,
	GET_FREE_CREDIT_TRANSACTION_LIST: `${CREDIT_BASE_URL}/getFreeCreditTransactionList`
};

export const SHIPPING_PARTNERS = {
	GET_DELIVERY_COMPANIES: `${SHIPPING_PARTNER_BASE_URL}/getDeliveryCompanies`,
	GET_DELIVERY_COMPANY_FORM: `${SHIPPING_PARTNER_BASE_URL}/getDeliveryCompanyTemplate`,
	GET_CONNECTED_DELIVERY_COMPANIES: `${SHIPPING_PARTNER_BASE_URL}/getConnectedDeliveryCompanies`,
	TEST_CONNECTION_SERVICE_DC: `${SHIPPING_PARTNER_BASE_URL}/testDCConnection`,
	ADD_DELIVERY_CHANNEL_SETTINGS: `${SHIPPING_PARTNER_BASE_URL}/addDeliveryChannelSettings`,
	UPDATE_DELIVERY_CHANNEL_SETTINGS: `${SHIPPING_PARTNER_BASE_URL}/updateDeliveryChannelSettings`,
	GET_DELIVERY_COMPANY_FORM_SETTINGS: `${SHIPPING_PARTNER_BASE_URL}/getDeliveryChannelSettings`,
	DELETE_CONNECTED_DELIVERY_CHANNEL: `${SHIPPING_PARTNER_BASE_URL}/deleteConnectedDeliveryCompany`,
	GET_CITY_COVERAGE_LIST: `${SHIPPING_PARTNER_BASE_URL}/getCitySettingsByDCSettingsID`,
	UPDATE_CITY_COVERAGE_LIST: `${SHIPPING_PARTNER_BASE_URL}/updateCitySettingsByDCSettingsID`,

	// SUPPORT
	GET_DC_PICKUP_LOCATION_LIST: `${SHIPPING_PARTNER_BASE_URL}/getDeliveryCompanyPickupLocationList`,
	GET_DC_PICKUP_LOCATION: `${SHIPPING_PARTNER_BASE_URL}/getDeliveryCompanyPickupLocation`,
	ADD_DC_PICKUP_LOCATION: `${SHIPPING_PARTNER_BASE_URL}/addDeliveryCompanyPickupLocation`,
	UPDATE_DC_PICKUP_LOCATION: `${SHIPPING_PARTNER_BASE_URL}/updateDeliveryCompanyPickupLocation`,
	DELETE_DC_PICKUP_LOCATION: `${SHIPPING_PARTNER_BASE_URL}/deleteDeliveryCompanyPickupLocation`,
	SEND_DC_PICKUP_LOCATION_EMAIL: `${SHIPPING_PARTNER_BASE_URL}/sendDeliveryCompanyPickupLocationEmail`,

	GET_ALLOWED_GROUP_STATUS_TRANSITION_LIST: `${SHIPPING_PARTNER_BASE_URL}/getAllowedGroupStatusTransitionList`,

	GET_SHIPPING_PARTNER_SLA_METHOD: `${PRICE_CALCULATOR_BASE_URL}/getSlaMethodTypeForCompany`,
	UPDATE_SHIPPING_PARTNER_SLA_METHOD: `${PRICE_CALCULATOR_BASE_URL}/updateSlaMethodTypeForCompany`,
	ADD_CITY_SLA_METHOD: `${PRICE_CALCULATOR_BASE_URL}/addCityBasedSlaForCompany`,
	DELETE_CITY_SLA_METHOD: `${PRICE_CALCULATOR_BASE_URL}/deleteCityBasedSlaForCompany`,
	DELETE_COUNTRY_SLA_METHOD: `${PRICE_CALCULATOR_BASE_URL}/deleteCountryBasedSlaForCompany`,
	GET_CITY_SLA_METHOD_LIST: `${PRICE_CALCULATOR_BASE_URL}/getCityBasedSlaListForCompany`,
	ADD_TIER_SLA_METHOD: `${PRICE_CALCULATOR_BASE_URL}/addTierBasedSlaForCompany`,
	DELETE_TIER_SLA_METHOD: `${PRICE_CALCULATOR_BASE_URL}/deleteTierBasedSlaForCompany`,
	GET_TIER_SLA_METHOD_LIST: `${PRICE_CALCULATOR_BASE_URL}/getTierBasedSlaListForCompany`,
	ADD_KM_SLA_METHOD: `${PRICE_CALCULATOR_BASE_URL}/addKmBasedSlaForCompany`,
	DELETE_KM_SLA_METHOD: `${PRICE_CALCULATOR_BASE_URL}/deleteKmBasedSlaForCompany`,
	GET_KM_SLA_METHOD_LIST: `${PRICE_CALCULATOR_BASE_URL}/getKmBasedSlaListForCompany`,
	ADD_DISTRICT_SLA_METHOD: `${PRICE_CALCULATOR_BASE_URL}/addDistrictBasedSlaForCompany`,
	DELETE_DISTRICT_SLA_METHOD: `${PRICE_CALCULATOR_BASE_URL}/deleteDistrictBasedSlaForCompany`,
	GET_DISTRICT_SLA_METHOD_LIST: `${PRICE_CALCULATOR_BASE_URL}/getDistrictBasedSlaListForCompany`,
	ADD_BULLET_KM_SLA_METHOD: `${PRICE_CALCULATOR_BASE_URL}/addBulletKmSlaForCompany`,
	DELETE_BULLET_KM_SLA_METHOD: `${PRICE_CALCULATOR_BASE_URL}/deleteBulletKmSlaForCompany`,
	GET_BULLET_KM_SLA_METHOD_LIST: `${PRICE_CALCULATOR_BASE_URL}/getBulletKmSlaListForCompany`,
	ADD_COUNTRY_SLA_METHOD: `${PRICE_CALCULATOR_BASE_URL}/addCountryBasedSlaForCompany`,
	GET_COUNTRY_SLA_METHOD_LIST: `${PRICE_CALCULATOR_BASE_URL}/getCountryBasedSlaListForCompany`,

	GET_DELIVERY_SLOT_METHOD: `${DELIVERY_SLOT_BASE_URL}/getDeliverySlot`,
	GET_DELIVERY_SLOT_LIST_METHOD: `${DELIVERY_SLOT_BASE_URL}/getDeliverySlotList`,
	GET_ALL_DELIVERY_SLOT: `${DELIVERY_SLOT_BASE_URL}/getAllDeliverySlot`,
	ADD_DELIVERY_SLOT_METHOD: `${DELIVERY_SLOT_BASE_URL}/addDeliverySlot`,
	DELETE_DELIVERY_SLOT_METHOD: `${DELIVERY_SLOT_BASE_URL}/deleteDeliverySlot`,
	EDIT_DELIVERY_SLOT_METHOD: `${DELIVERY_SLOT_BASE_URL}/editDeliverySlotList`,

	// IMPORT-EXPORT
	GET_TIER_BASED_SLA_TEMPLATE_FOR_COMPANY: `${PRICE_CALCULATOR_BASE_URL}/getTierBasedSlaTemplateForCompany`,
	GET_KM_BASED_SLA_TEMPLATE_FOR_COMPANY: `${PRICE_CALCULATOR_BASE_URL}/getKmBasedSlaTemplateForCompany`,
	GET_DISTRICT_BASED_SLA_TEMPLATE_FOR_COMPANY: `${PRICE_CALCULATOR_BASE_URL}/getDistrictBasedSlaTemplateForCompany`,
	GET_CITY_BASED_SLA_TEMPLATE_FOR_COMPANY: `${PRICE_CALCULATOR_BASE_URL}/getCityBasedSlaTemplateForCompany`,
	GET_BULLET_KM_SLA_TEMPLATE_FOR_COMPANY: `${PRICE_CALCULATOR_BASE_URL}/getBulletKmSlaTemplateForCompany`,
	GET_COUNTRY_BASED_SLA_TEMPLATE_FOR_COMPANY: `${PRICE_CALCULATOR_BASE_URL}/getCountryBasedSlaTemplateForCompany`,
	IMPORT_TIER_BASED_SLA_FOR_COMPANY: `${PRICE_CALCULATOR_BASE_URL}/importTierBasedSlaForCompany`,
	IMPORT_KM_BASED_SLA_FOR_COMPANY: `${PRICE_CALCULATOR_BASE_URL}/importKmBasedSlaForCompany`,
	IMPORT_DISTRICT_BASED_SLA_FOR_COMPANY: `${PRICE_CALCULATOR_BASE_URL}/importDistrictBasedSlaForCompany`,
	IMPORT_CITY_BASED_SLA_FOR_COMPANY: `${PRICE_CALCULATOR_BASE_URL}/importCityBasedSlaForCompany`,
	IMPORT_BULLET_KM_SLA_FOR_COMPANY: `${PRICE_CALCULATOR_BASE_URL}/importBulletKmSlaForCompany`,
	IMPORT_COUNTRY_BASED_SLA_FOR_COMPANY: `${PRICE_CALCULATOR_BASE_URL}/importCountryBasedSlaForCompany`
};

export const OTHER_INTEGRATIONS = {
	GET_INTEGRATIONS: `${OTHER_INTEGRATIONS_BASE_URL}/getIntegrations`,
	GET_CONNNECTED_INTEGRATIONS: `${OTHER_INTEGRATIONS_BASE_URL}/getConnectedIntegrations`,
	GET_WEBHOOKS: `${OTHER_INTEGRATIONS_BASE_URL}/getIntegrationWebhook`,
	GET_SMS_PROVIDERS: `${OTHER_INTEGRATIONS_BASE_URL}/getIntegrationSms`,
	GET_CONNECTED_SMS_PROVIDERS: `${OTHER_INTEGRATIONS_BASE_URL}/getConnectedIntegrationsSms`,
	ADD_SMS_PROVIDER: `${OTHER_INTEGRATIONS_BASE_URL}/addSMSProvider`,
	UPDATE_SMS_PROVIDER: `${OTHER_INTEGRATIONS_BASE_URL}/updateSMSProvider`,
	GET_SMS_PROVIDER: `${OTHER_INTEGRATIONS_BASE_URL}/getSMSProvider`,
	DELETE_SMS_PROVIDER: `${OTHER_INTEGRATIONS_BASE_URL}/deleteSMSProvider`,
	UPDATE_SMS_STATUS: `${OTHER_INTEGRATIONS_BASE_URL}/updateSMSStatus`
};

export const SMS = {
	GET_SMS_SETTINGS_LIST: `${SMS_BASE_URL}/getSMSSettingList`,
	GET_SMS_SETTINGS: `${SMS_BASE_URL}/getSMSSettings`,
	ADD_SMS_SETTINGS: `${SMS_BASE_URL}/addSMSSettings`,
	UPDATE_SMS_SETTINGS: `${SMS_BASE_URL}/updateSMSSettings`,
	SEND_SMS_ACTION: `${SMS_BASE_URL}/sendSMSAction`,
	GET_RETURN_REQUEST_LINK: `${SMS_BASE_URL}/getReturnRequestLink`,
	GET_CONTENT_PREFERENCES: `${SMS_BASE_URL}/getAdsSettings`,
	DELETE_CONTENT_PREFERENCES: `${SMS_BASE_URL}/deleteAdsSettings`,
	UPDATE_CONTENT_PREFERENCES: `${SMS_BASE_URL}/updateAdsSettings`,
	ADD_CONTENT_PREFERENCES: `${SMS_BASE_URL}/addAdsSettings`,
	SEND_TEST_SMS_ACTION: `${SMS_BASE_URL}/sendTestSMS`,
	DELETE_SMS_SETTING: `${SMS_BASE_URL}/deleteSMSSetting`
};

export const PRODUCTS = {
	GET_PRODUCT_LIST: `${PRODUCT_BASE_URL}/getProductList`,
	GET_PRODUCT: `${PRODUCT_BASE_URL}/getProduct`,
	ADD_PRODUCT: `${PRODUCT_BASE_URL}/addProduct`,
	UPDATE_PRODUCT: `${PRODUCT_BASE_URL}/updateProduct`,
	DELETE_PRODUCT: `${PRODUCT_BASE_URL}/deleteProduct`,
	PRODUCT_SYNC_ALL_CHANNELS: `${PRODUCT_SYNC_BASE_URL}/productSyncAllChannels`,
	PRODUCT_SYNC_BY_SALES_CHANNEL_ID: `${PRODUCT_SYNC_BASE_URL}/productSyncBySalesChannelID`,
	GET_HS_CODES: `${PRODUCT_BASE_URL}/getHSCodes`
};

export const BRAND = {
	GET_CUSTOMIZABLE_PAGES_LIST: `${BRAND_BASE_URL}/getBrandedPagesList`,
	ADD_CUSTOMIZABLE_PAGE: `${BRAND_BASE_URL}/addBrandedPage`,
	UPDATE_CUSTOMIZABLE_PAGE: `${BRAND_BASE_URL}/updateBrandedPage`,
	GET_BRANDED_PAGE: `${BRAND_BASE_URL}/getBrandedPage`,
	GET_BRAND_LIST: `${BRAND_BASE_URL}/getBrandList`,
	GET_BRAND_SETTINGS: `${BRAND_BASE_URL}/getBrandSettings`,
	ADD_BRAND: `${BRAND_BASE_URL}/addBrand`,
	UPDATE_BRAND: `${BRAND_BASE_URL}/updateBrand`,
	DELETE_BRAND: `${BRAND_BASE_URL}/deleteBrand`,
	GET_BRAND_USER_PRODUCT_LIST: `${BRAND_BASE_URL}/getBrandUserProductList`,
	GET_BRAND_INVENTORY_LIST: `${BRAND_BASE_URL}/getBrandInventoryList`,
	GET_BRAND_ORDERS_LIST: `${BRAND_BASE_URL}/getBrandOrderList`
};

export const WEBHOOK = {
	GET_WEBHOOK_BY_ID: `${WEBHOOK_SETTINGS_BASE_URL}/getWebhookSettingsById`,
	GET_WEBHOOK_SETTINGS: `${WEBHOOK_SETTINGS_BASE_URL}/getWebhookSettings`,
	DELETE_WEBHOOK_SETTINGS: `${WEBHOOK_SETTINGS_BASE_URL}/deleteWebhookSettings`,
	UPDATE_WEBHOOK_SETTINGS: `${WEBHOOK_SETTINGS_BASE_URL}/updateWebhookSettings`,
	ADD_WEBHOOK_SETTINGS: `${WEBHOOK_SETTINGS_BASE_URL}/addWebhookSettings`,
	TEST_WEBHOOK_SETTINGS: `${WEBHOOK_SETTINGS_BASE_URL}/testWebhook`
};

export const OTOFLEX = {
	GET_DRIVER_LIST: `${OTOFLEX_BASE_URL}/getDriverList`,
	GET_UNASSIGNED_ORDER_LIST: `${OTOFLEX_BASE_URL}/getUnassignedOrderList`,
	GET_PROCESSING_ORDER_LIST: `${OTOFLEX_BASE_URL}/getProcessingOrderList`,
	GET_HISTORY_ORDER_LIST: `${OTOFLEX_BASE_URL}/getHistoryOrderList`,
	ADD_DRIVER: `${OTOFLEX_BASE_URL}/addDriver`,
	GET_DRIVER: `${OTOFLEX_BASE_URL}/getDriver`,
	UPDATE_DRIVER: `${OTOFLEX_BASE_URL}/updateDriver`,
	ADD_TRANSACTION: `${OTOFLEX_BASE_URL}/addTransaction`,
	GET_TRANSACTIONS: `${OTOFLEX_BASE_URL}/getDriverTransactionList`,
	UPDATE_DRIVER_STATUS: `${OTOFLEX_BASE_URL}/updateDriverStatus`,
	TRACK_DRIVER: `${OTOFLEX_BASE_URL}/trackDriver`,
	MAP_DRIVER_LIST: `${OTOFLEX_BASE_URL}/getMapViewInfo`,
	CANCEL_DRIVER: `${OTOFLEX_BASE_URL}/cancelDriver`,
	BROADCAST_TO_FLEET: `${OTOFLEX_BASE_URL}/broadcastToFleet`,
	BULK_BROADCAST_TO_FLEET: `${OTOFLEX_BASE_URL}/broadcastBulkToFleet`,
	GET_PROOFS: `${OTOFLEX_BASE_URL}/getProofOfDelivery`,
	GET_OTO_FLEX_SETTINGS: `${OTOFLEX_BASE_URL}/getOtoFlexFormSettings`,
	UPDATE_OTO_FLEX_SETTINGS: `${OTOFLEX_BASE_URL}/updateOtoFlexFormSettings`,
	GET_ASSIGNABLE_DRIVERS: `${OTOFLEX_BASE_URL}/getAssignableDrivers`
};
export const OTO_LINK = {
	GET_ALL_OTO_LINKS: `${OTOLINK_BASE_URL}/getAllOTOLinks`,
	GET_OTO_LINK: `${OTOLINK_BASE_URL}/getOTOLink`,
	GET_USED_OTO_LINKS: `${OTOLINK_BASE_URL}/getUsedOTOLinks`,
	GET_OTO_LINK_SESSION_LOGS: `${OTOLINK_BASE_URL}/getOTOLinkSessionLogsBySessionId`,
	ADD_OTO_LINK: `${OTOLINK_BASE_URL}/addOTOLink`,
	UPDATE_OTO_LINK: `${OTOLINK_BASE_URL}/updateOTOLink`,
	UPDATE_OTO_LINK_STATUS: `${OTOLINK_BASE_URL}/updateOTOLinkStatus`,
	GET_OTO_LINK_SETTINGS: `${OTOLINK_BASE_URL}/getOTOLinkSettings`,
	UPDATE_OTO_LINK_SETTINGS: `${OTOLINK_BASE_URL}/updateOTOLinkSettings`,
	ADD_OTO_LINK_SETTINGS: `${OTOLINK_BASE_URL}/addOTOLinkSettings`,
	GET_OTO_LINK_TRANSACTIONS: `${OTOLINK_BASE_URL}/getOTOLinkTransactions`,
	GET_OTO_LINK_ORDERS: `${OTOLINK_BASE_URL}/getOTOLinkOrders`,
	CANCEL_OTO_LINK_ORDER: `${OTOLINK_BASE_URL}/cancelOrdersOTOLink`,
	UPDATE_BANK_INFO: `${OTOLINK_BASE_URL}/updateBankInfoFirstTime`,

	// open
	GET_OTO_LINK_BUYER: `${OPEN_OTO_LINK_URL}/getOTOLinkBuyer`,
	UPDATE_OTO_LINK_BUYER_CONTACT_DETAILS: `${OPEN_OTO_LINK_URL}/updateOTOLinkBuyerContactDetails`,
	UPDATE_OTO_LINK_BUYER_PAYMENT_METHOD: `${OPEN_OTO_LINK_URL}/updateOTOLinkBuyerPaymentMethod`,
	UPDATE_OTO_LINK_BUYER_SHIPPING_METHOD: `${OPEN_OTO_LINK_URL}/updateOTOLinkBuyerShippingMethod`,
	UPDATE_OTO_LINK_BUYER_CHECKOUT: `${OPEN_OTO_LINK_URL}/updateOTOLinkBuyerCheckout`,
	GET_OTO_LINK_BUYER_DC_PRICES: `${OPEN_OTO_LINK_URL}/getOTOLinkBuyerDCPrices`,
	MAKE_CHARGE: `${OPEN_OTO_LINK_URL}/otoLinkMakeCharge`,
	UPDATE_OTO_LINK_COD_PAYMENT: `${OPEN_OTO_LINK_URL}/updateOTOLinkCODPayment`,
	CHECK_CHARGE: `${OPEN_OTO_LINK_URL}/otoLinkCheckCharge`
};

export const OTO_STORE = {
	GET_PRODUCTS: `${OTO_STORE_BASE_URL}/getOTOStoreProducts`,
	GET_ORDERS: `${OTO_STORE_BASE_URL}/getOTOStoreOrders`,
	GET_CART_DETAILS: `${OTO_STORE_BASE_URL}/getCartDetails`,
	UPDATE_CART: `${OTO_STORE_BASE_URL}/updateCart`,
	GET_PRODUCT_DETAILS: `${OTO_STORE_BASE_URL}/getProductDetails`,
	CREATE_ORDER: `${OTO_STORE_BASE_URL}/createOTOStoreOrder`,
	GET_ORDER_BY_ID: `${OTO_STORE_BASE_URL}/getOTOStoreOrderByID`,
	GET_ORDER_STATUSES_BY_ID: `${OTO_STORE_BASE_URL}/getOTOStoreOrderStatusesByID`
};

export const ORDERS = {
	GET_PENDING_ORDER_LIST: `${ORDER_BASE_URL}/getPendingOrderList`,
	GET_AWAITING_PICKUP_ORDER_LIST: `${ORDER_BASE_URL}/getAwaitingPickupOrderList`,
	GET_CURRENTLY_SHIPPING_ORDER_LIST: `${ORDER_BASE_URL}/getShippingOrderList`,
	GET_ON_HOLD_ORDER_LIST: `${ORDER_BASE_URL}/getOnHoldOrderList`,
	GET_DELIVERED_ORDER_LIST: `${ORDER_BASE_URL}/getDeliveredOrderList`,
	GET_RETURNED_ORDER_LIST: `${ORDER_BASE_URL}/getReturnedOrderList`,
	GET_CANCELED_ORDER_LIST: `${ORDER_BASE_URL}/getCanceledOrderList`,
	GET_ALL_ORDER_LIST: `${ORDER_BASE_URL}/getAllOrderList`,

	GET_AUTO_FILL_ORDER_ID: `${ORDER_BASE_URL}/getAutoFillOrderID`,
	GET_AUTO_FILL_CUSTOMER_DETAILS: `${ORDER_BASE_URL}/getAutoFillCustomerDetails`,
	GET_ORDER_BY_ID: `${ORDER_BASE_URL}/getOrderByID`,
	GET_ORDERS_BY_AREA: `${ORDER_BASE_URL}/getOrdersByArea`,
	GET_ORDERS_BY_SEARCH: `${ORDER_BASE_URL}/getOrdersBySearch`,
	GET_ORDERS_BY_SEARCH_FOR_OPERATION: `${ORDER_BASE_URL}/getOrdersBySearchForOperation`,
	GET_ORDER_SUMMARY_BY_ID: `${ORDER_BASE_URL}/getOrderSummary`,
	GET_ORDER_SUMMARY_BY_ID_V2: `${ORDER_BASE_URL}/getOrderSummaryV2`,
	GET_ORDER_ITEMS_BY_ID: `${ORDER_BASE_URL}/getOrderItemsByOrderID`,
	GET_ORDER_COMMENTS_BY_ID: `${ORDER_BASE_URL}/getOrderCommentsByID`,
	GET_ORDER_STATUSES_BY_ID: `${ORDER_BASE_URL}/getStatusLogsByID`,
	GET_ORDER_PACKING_STATUS_BY_ID: `${ORDER_BASE_URL}/getWMSStatusLogsByID`,
	GET_RETURNED_ORDER_DETAILS: `${ORDER_BASE_URL}/getReturnedOrderDetails`,
	GET_ORDERS_BY_WAREHOUSE_ID_AND_ORDER_TYPES: `${ORDER_BASE_URL}/getOrderListForWaveCreation`,
	GET_TRACKING_STATUS_BY_ID: `${ORDER_BASE_URL}/getTrackingPageInfo`,

	GET_MAP_ORDERS_LIST: `${ORDER_BASE_URL}/getMapOrdersList`,
	GET_AGGREGATOR_ORDERS: `${ORDER_BASE_URL}/getAggregatorOrders`,
	GET_BULLET_ORDERS: `${ORDER_BASE_URL}/getBulletOrders`,

	GET_OPERATION_ALL_ORDERS: `${ORDER_BASE_URL}/getAllOrderOperationList`,
	GET_OPERATION_NEED_ACTION_ORDER: `${ORDER_BASE_URL}/getNeedActionOrderOperationList`,
	GET_HEATMAP_ORDER_LIST: `${ORDER_BASE_URL}/getHeatMapOrderList`,
	GET_ORDER_PIN_DETAILS_BY_ID: `${ORDER_BASE_URL}/getOrderPinDetailsByID`,
	GET_ORDER_BOXES_BY_ORDER_ID: `${ORDER_BASE_URL}/getOrderBoxesByOrderID`,

	GET_BULLET_SHIPMENT_NUMBERS: `${ORDER_BASE_URL}/getDashboardBulletOrders`,
	GET_BULLET_COMPLETED_BULLET_ORDERS: `${ORDER_BASE_URL}/getCompletedBulletOrders`,
	GET_BULLET_NOT_COMPLETED_BULLET_ORDERS: `${ORDER_BASE_URL}/getNotCompletedBulletOrders`,
	GET_BULLET_ORDERS_DC_LIST: `${ORDER_BASE_URL}/getBulletOrdersDeliveryCompanyList`,
	GET_BULLET_PERFORMANCE: `${ORDER_BASE_URL}/getBulletPerformance`,
	CHECK_IS_ORDER_INTERNATIONAL: `${ORDER_BASE_URL}/checkInternational`
};

export const ORDER_ACTIONS = {
	CREATE_SHIPMENT: `${ORDER_ACTIONS_BASE_URL}/createShipment`,
	CREATE_SHIPMENT_AUTOMATICALLY: `${ORDER_ACTIONS_BASE_URL}/createShipmentAutomatically`,
	CREATE_SHIPMENT_AND_PRINT: `${ORDER_ACTIONS_BASE_URL}/createShipmentAndPrint`,
	CANCEL_SHIPMENT: `${ORDER_ACTIONS_BASE_URL}/cancelShipment`,
	CANCEL_SHIPMENT_ADMIN: `${ORDER_ACTIONS_BASE_URL}/cancelShipmentAdmin`,
	DELETE_ORDER: `${ORDER_ACTIONS_BASE_URL}/deleteOrder`,
	UPDATE_ORDER_STATUS: `${ORDER_ACTIONS_BASE_URL}/updateOrderStatus`,
	CHECK_AGGREGATOR_FOR_MARK_AS_DELIVERED: `${ORDER_ACTIONS_BASE_URL}/checkAggregatorForMarkAsDelivered`,
	SYNCHRONIZE_ORDER: `${ORDER_ACTIONS_BASE_URL}/synchronizeOrder`,
	SEND_BACK_TO_PENDING: `${ORDER_ACTIONS_BASE_URL}/sendBackToPending`,
	SPLIT_ORDER: `${ORDER_ACTIONS_BASE_URL}/splitOrder`,
	REALLOCATE_ORDER: `${ORDER_ACTIONS_BASE_URL}/reallocateOrder`,
	CANCEL_ORDERS: `${ORDER_ACTIONS_BASE_URL}/cancelOrders`,
	MARK_AS_PICKED_UP: `${ORDER_ACTIONS_BASE_URL}/markAsPickedUp`,
	MARK_AS_PICKED: `${ORDER_ACTIONS_BASE_URL}/markAsPickedByIds`,
	MARK_AS_PACKED: `${ORDER_ACTIONS_BASE_URL}/markAsPackedByIds`,
	MARK_AS_DESTROYED: `${ORDER_ACTIONS_BASE_URL}/markAsDestroyed`,
	MARK_AS_NOT_AVAILABLE: `${ORDER_ACTIONS_BASE_URL}/markAsNotAvailable`,
	ACCEPT_ORDER: `${ORDER_ACTIONS_BASE_URL}/acceptBranch`,
	REJECT_ORDER: `${ORDER_ACTIONS_BASE_URL}/rejectBranch`,
	GET_RETURN_CONFIRMATION: `${ORDER_ACTIONS_BASE_URL}/getReturnConfirmation`,
	UPDATE_RETURN_REASON: `${ORDER_ACTIONS_BASE_URL}/updateReturnReason`,
	UPDATE_RETURN_CONFIRMATION: `${ORDER_ACTIONS_BASE_URL}/updateReturnConfirmation`,
	UPDATE_RETURN_CONFIRMATION_MULTIPLE: `${ORDER_ACTIONS_BASE_URL}/updateReturnConfirmationMultiple`,
	UPDATE_ON_HOLD_REASON: `${ORDER_ACTIONS_BASE_URL}/updateOnHoldReason`,
	CLICK_AND_COLLECT_UPDATE: `${ORDER_ACTIONS_BASE_URL}/clickAndCollectUpdate`, // Requested https://app.clickup.com/t/8669mv0k8
	UPDATE_COLLECTED_BY_CUSTOMER: `${ORDER_ACTIONS_BASE_URL}/updateCollectedByCustomer`,
	ASSIGN_TO_DRIVER_UPDATE: `${ORDER_ACTIONS_BASE_URL}/assignToDriverUpdate`,
	ADD_COMMENT_TO_ORDER: `${ORDER_ACTIONS_BASE_URL}/addCommentToOrder`,
	ADD_ORDER_ITEM: `${ORDER_ACTIONS_BASE_URL}/addOrderItem`,
	UPDATE_ORDER_ITEM: `${ORDER_ACTIONS_BASE_URL}/updateOrderItem`,
	DELETE_ORDER_ITEM: `${ORDER_ACTIONS_BASE_URL}/deleteOrderItem`,
	ADD_ORDER: `${ORDER_ACTIONS_BASE_URL}/addOrder`,
	UPDATE_ORDER: `${ORDER_ACTIONS_BASE_URL}/updateOrder`,
	UPDATE_RETURN_ORDER: `${ORDER_ACTIONS_BASE_URL}/updateReturnOrder`,
	GET_SERIAL_NUMBER_DETAILS: `${ORDER_ACTIONS_BASE_URL}/getSerialNumberDetails`,
	UPDATE_SERIAL_NUMBER: `${ORDER_ACTIONS_BASE_URL}/updateSerialNumber`,
	RESEND_ECOM_UPDATE: `${ORDER_ACTIONS_BASE_URL}/resendEcommerceUpdate`,
	RESEND_ECOM_UPDATE_DEKSTOP: `${ORDER_ACTIONS_BASE_URL}/resendEcommerceUpdateDesktop`,
	PAYMENT_METHOD_CONFIRMATION: `${ORDER_ACTIONS_BASE_URL}/paymentMethodConfirmationById`,
	COD_ORDER_CONFIRMATION: `${ORDER_ACTIONS_BASE_URL}/codOrderConfirmation`,
	REVIEW_PICKING_MARK_AS_PICKED: `${ORDER_ACTIONS_BASE_URL}/reviewPickingMarkAsPicked`,
	REVIEW_PICKING_CONFIRM_MISSING_ITEMS: `${ORDER_ACTIONS_BASE_URL}/reviewPickingConfirmMissingItems`,
	REVIEW_PICKING_SEND_BACK_TO_PICKING: `${ORDER_ACTIONS_BASE_URL}/reviewPickingSendBackToPicking`,
	ADD_ORDER_DOCUMENT: `${ORDER_ACTIONS_BASE_URL}/addOrderDocument`,
	UPDATE_ORDER_DOCUMENT: `${ORDER_ACTIONS_BASE_URL}/updateOrderDocument`,
	DELETE_ORDER_DOCUMENT: `${ORDER_ACTIONS_BASE_URL}/deleteOrderDocument`,
	GET_ORDER_DOCUMENTS: `${ORDER_ACTIONS_BASE_URL}/getOrderDocuments`,
	DELETE_ORDER_BOX: `${ORDER_ACTIONS_BASE_URL}/deleteOrderBox`,
	CHECK_SHIPMENT_STATUS: `${ORDER_ACTIONS_BASE_URL}/checkShipmentStatus`,
	CHANGE_DELIVERY_SLOT_BULK: `${ORDER_ACTIONS_BASE_URL}/changeDeliverySlotBulk`,
	GENERATE_PICKUP_ID: `${ORDER_ACTIONS_BASE_URL}/generatePickUpId`,
	CANCEL_BULLET_DELIVERY_CONFIRMATION: `${ORDER_ACTIONS_BASE_URL}/cancelBulletDeliveryConfirmation`,
	CANCEL_SHIPMENT_CONFIRMATION_MESSAGE: `${ORDER_ACTIONS_BASE_URL}/getCancelShipmentMessage`,
	EDIT_INTEGRATOR_ORDER_ADMIN: `${ORDER_ACTIONS_BASE_URL}/updateAdminOrderShipmentDetails`,
	GET_INTEGRATOR_ORDER_ADMIN: `${ORDER_ACTIONS_BASE_URL}/getAdminOrderShipmentDetails`,
	CREATE_HELPDESK_TICKET: `${ORDER_ACTIONS_BASE_URL}/createHelpdeskTicket`,
	GET_DC_STATUS_HISTORY: `${ORDER_ACTIONS_BASE_URL}/checkStatus`,
	UPDATE_SERIAL_NUMBER_BY_ITEM_ID: `${ORDER_ACTIONS_BASE_URL}/updateSerialNumberByItemId`
};

export const WAREHOUSES = {
	GET_WAREHOUSE_LIST: `${WAREHOUSE_BASE_URL}/getWarehouseList`,
	GET_WAREHOUSE: `${WAREHOUSE_BASE_URL}/getWarehouse`,
	ADD_WAREHOUSE: `${WAREHOUSE_BASE_URL}/addWarehouse`,
	UPDATE_WAREHOUSE: `${WAREHOUSE_BASE_URL}/updateWarehouse`,
	UPDATE_WAREHOUSE_STATUS: `${WAREHOUSE_BASE_URL}/updateWarehouseStatus`,
	GET_PICKUP_LOCATION: `${WAREHOUSE_BASE_URL}/getPickupLocation`,
	UPDATE_PICKUP_LOCATION: `${WAREHOUSE_BASE_URL}/updatePickupLocation`,
	GET_PACKING_LIST: `${WAREHOUSE_BASE_URL}/getPackingList`,
	UPDATE_WAREHOUSE_RADIUS: `${WAREHOUSE_BASE_URL}/updateRadiusForWarehouses`
};

export const WMS_MODULE = {
	GET_INBOUND_LIST: `${WMS_BASE_URL}/getInventoryOrdersList`,
	GET_INBOUND: `${WMS_BASE_URL}/getInventoryOrder`,
	ADD_INBOUND: `${WMS_BASE_URL}/addInbound`,
	UPDATE_INBOUND: `${WMS_BASE_URL}/updateInbound`,
	GET_INVENTORY_LIST: `${WMS_BASE_URL}/getInventoryList`,
	GET_GLOBAL_INVENTORY_LIST: `${WMS_BASE_URL}/getGlobalInventoryList`,
	GET_INVENTORY_TRANSACTIONS_LIST: `${WMS_BASE_URL}/getInventoryTransactionsList`,
	ORDER_BASED_TRANSACTIONS_LIST: `${WMS_BASE_URL}/getOrderBasedTransactionReport`,
	UPDATE_INVENTORY_AND_BIN: `${WMS_BASE_URL}/updateInventoryAndBin`,
	GET_INVENTORY: `${WMS_BASE_URL}/getInventory`,
	ADD_INVENTORY: `${WMS_BASE_URL}/addInventory`,
	EDIT_INVENTORY: `${WMS_BASE_URL}/updateInventory`,
	UPDATE_MIN_INVENTORY: `${WMS_BASE_URL}/updateMinInventoryBulk`,
	UPDATE_ORDER_BASED_TRANSACTIONS: `${WMS_BASE_URL}/updateOrderBasedTransactions`,
	GET_SORTING_LIST: `${WMS_BASE_URL}/getSortingPageList`,
	UNASSIGN_ORDER: `${WMS_BASE_URL}/unassignOrderFromSortingBin`,
	// product attributes
	GET_PRODUCT_ATTRIBUTES_LIST: `${WMS_BASE_URL}/getProductAttributesList`,
	GET_PRODUCT_ATTRIBUTE: `${WMS_BASE_URL}/getProductAttribute`,
	ADD_PRODUCT_ATTRIBUTE: `${WMS_BASE_URL}/addProductAttribute`,
	UPDATE_PRODUCT_ATTRIBUTE: `${WMS_BASE_URL}/updateProductAttribute`,
	DELETE_PRODUCT_ATTRIBUTE: `${WMS_BASE_URL}/deleteProductAttribute`,
	ASSIGN_PRODUCT_GROUP: `${WMS_BASE_URL}/assignProductGroup`,
	UNASSIGN_PRODUCT_GROUP: `${WMS_BASE_URL}/unassignProductGroup`,
	// attributes groups
	GET_ATTRIBUTES_GROUPS: `${WMS_BASE_URL}/getProductGroups`,
	GET_ATTRIBUTES_GROUPS_LIST: `${WMS_BASE_URL}/getProductGroupsList`,
	GET_ATTRIBUTES_GROUP: `${WMS_BASE_URL}/getProductGroup`,
	ADD_ATTRIBUTES_GROUP: `${WMS_BASE_URL}/addProductGroup`,
	DELETE_ATTRIBUTES_GROUP: `${WMS_BASE_URL}/deleteProductGroup`
};

export const PURCHASE_ORDER = {
	GET_PURCHASE_ORDERS: `${PO_BASE_URL}/getPurchaseOrders`,
	GET_PURCHASE_ORDER: `${PO_BASE_URL}/getPurchaseOrder`,
	UPDATE_PURCHASE_ORDER: `${PO_BASE_URL}/updatePurchaseOrder`,
	UPDATE_PURCHASE_ORDER_STATUS: `${PO_BASE_URL}/updatePurchaseOrderStatus`,
	DELETE_PURCHASE_ORDER: `${PO_BASE_URL}/deletePurchaseOrder`,
	DELETE_PURCHASE_ORDER_ITEM: `${PO_BASE_URL}/deletePurchaseOrderItem`,
	ADD_PURCHASE_ORDER: `${PO_BASE_URL}/addPurchaseOrder`
};

export const ADVANCE_WMS_MODULE = {
	WAVE_BASED_TRANSACTIONS_LIST: `${ADVANCE_WMS_BASE_URL}/getWaveBasedTransactionReport`,
	CONFIGURE_OTOPACK: `${ADVANCE_WMS_BASE_URL}/configureOtopack`,
	GET_CONFIGURE_OTOPACK: `${ADVANCE_WMS_BASE_URL}/getConfigureOtopack`,
	GET_INBOUND_ORDERS_LIST: `${ADVANCE_WMS_BASE_URL}/getInboundList`,
	GET_OUTBOUND_ORDERS_LIST: `${ADVANCE_WMS_BASE_URL}/getOutboundList`,
	DELETE_INVENTORY_TRANSACTION: `${ADVANCE_WMS_BASE_URL}/deleteInventoryTransaction`,
	UPDATE_INVENTORY: `${ADVANCE_WMS_BASE_URL}/updateInventory`,
	DELETE_INVENTORY: `${ADVANCE_WMS_BASE_URL}/deleteInventory`,
	DELETE_INVENTORY_ORDER: `${ADVANCE_WMS_BASE_URL}/deleteInventoryOrder`,
	UPDATE_QUANTITY_AVAILABLE: `${ADVANCE_WMS_BASE_URL}/updateQuantityAvailableAction`,
	EQUAL_QUANTITY_ONHAND: `${ADVANCE_WMS_BASE_URL}/equalQuantityOnHandToBinInventoryAction`,
	REVERTE_INVENTORY: `${ADVANCE_WMS_BASE_URL}/revertInventory`,
	START_INBOUND: `${ADVANCE_WMS_BASE_URL}/startInbound`,
	ASSIGN_RESPONSIBLE_INBOUND: `${ADVANCE_WMS_BASE_URL}/assignInboundResponsible`,
	COMPLETE_INBOUND: `${ADVANCE_WMS_BASE_URL}/completeInbound`,
	START_OUTBOUND: `${ADVANCE_WMS_BASE_URL}/startInbound`,
	ASSIGN_RESPONSIBLE_OUTBOUND: `${ADVANCE_WMS_BASE_URL}/assignOutboundResponsible`,
	COMPLETE_OUTBOUND: `${ADVANCE_WMS_BASE_URL}/completeOutboundOrder`,
	ADD_BIN: `${ADVANCE_WMS_BASE_URL}/addBin`,
	GET_BINS_LIST: `${ADVANCE_WMS_BASE_URL}/getBinsList`,
	GET_BIN_BY_ID: `${ADVANCE_WMS_BASE_URL}/getBinById`,
	UPDATE_BIN: `${ADVANCE_WMS_BASE_URL}/updateBin`,
	DELETE_BIN: `${ADVANCE_WMS_BASE_URL}/deleteBin`,
	UPDATE_BIN_ZONE: `${ADVANCE_WMS_BASE_URL}/updateBinZone`,
	GET_BIN_TRANSACTIONS_LIST: `${ADVANCE_WMS_BASE_URL}/getBinTransactionsList`,
	GET_DAILY_STAFF_LIST: `${REPORT_LIST_BASE_URL}/getDailyStaffReport`,
	DELETE_BIN_TRANSACTION: `${ADVANCE_WMS_BASE_URL}/deleteBinTransaction`,
	GET_BIN_INVENTORY_LIST: `${ADVANCE_WMS_BASE_URL}/getBinInventory`,
	DELETE_BIN_INVENTORY: `${ADVANCE_WMS_BASE_URL}/deleteBinInventory`,
	GET_PICKING_EXCEPTIONS: `${ADVANCE_WMS_BASE_URL}/getPickingLogsList`,
	GET_ZONES_LIST: `${ADVANCE_WMS_BASE_URL}/getZonesList`,
	ADD_ZONE: `${ADVANCE_WMS_BASE_URL}/addZone`,
	UPDATE_ZONE: `${ADVANCE_WMS_BASE_URL}/editZone`,
	DELETE_ZONE: `${ADVANCE_WMS_BASE_URL}/deleteZone`,
	CHANGE_ZONE_STATUS: `${ADVANCE_WMS_BASE_URL}/changeZoneStatus`,
	GET_ZONE_BY_ID: `${ADVANCE_WMS_BASE_URL}/getZoneById`,
	GET_WAVES_LIST: `${ADVANCE_WMS_BASE_URL}/getWavesList`,
	START_WAVE_PICKING: `${ADVANCE_WMS_BASE_URL}/startWavePicking`,
	COMPLETE_WAVE_PICKING: `${ADVANCE_WMS_BASE_URL}/completePicking`,
	ASSIGN_PICKER: `${ADVANCE_WMS_BASE_URL}/assignPicker`,
	DELETE_WAVE: `${ADVANCE_WMS_BASE_URL}/deleteWave`,
	GET_WAVE_BY_ID: `${ADVANCE_WMS_BASE_URL}/getWaveById`,
	GET_PUTAWAY_LIST: `${ADVANCE_WMS_BASE_URL}/getPutAwayList`,
	GET_PUTAWAY_BY_ID: `${ADVANCE_WMS_BASE_URL}/getPutAwayById`,
	START_PUTAWAY: `${ADVANCE_WMS_BASE_URL}/startPutAway`,
	COMPLETE_PUTAWAY: `${ADVANCE_WMS_BASE_URL}/completePutAway`,
	EASY_PUTAWAY: `${ADVANCE_WMS_BASE_URL}/easyPut`,
	ADD_PUTAWAY: `${ADVANCE_WMS_BASE_URL}/addPutaway`,
	UPDATE_PUTAWAY: `${ADVANCE_WMS_BASE_URL}/editPutaway`,
	DELETE_PUTAWAY: `${ADVANCE_WMS_BASE_URL}/deletePutaway`,
	GET_PACKING_LIST: `${ADVANCE_WMS_BASE_URL}/getPackingList`,
	GET_WMS_USERS_LIST: `${ADVANCE_WMS_BASE_URL}/getWMSUsersList`,
	ADD_WMS_USER: `${ADVANCE_WMS_BASE_URL}/addUser`,
	EDIT_WMS_USER: `${ADVANCE_WMS_BASE_URL}/editUser`,
	GET_RETURN_LIST: `${ADVANCE_WMS_BASE_URL}/returnList`,
	CREATE_ZONE_WAVE: `${ADVANCE_WMS_BASE_URL}/createZoneWave`,
	CREATE_WAVE: `${ADVANCE_WMS_BASE_URL}/createWave`,
	INTER_DEPOT_TRANSFER: `${ADVANCE_WMS_BASE_URL}/addInterDepotTransfer`,
	ASSIGN_PICKER_ORDER: `${ADVANCE_WMS_BASE_URL}/assignPickerOrder`,
	NOT_AVAILABLE_ORDER: `${ADVANCE_WMS_BASE_URL}/notAvailableOrder`,
	COMPLETE_PACKING: `${ADVANCE_WMS_BASE_URL}/completePacking`,
	GET_VENDORS_LIST: `${ADVANCE_WMS_BASE_URL}/getVendorList`,
	ADD_VENDOR: `${ADVANCE_WMS_BASE_URL}/addVendor`,
	UPDATE_VENDOR: `${ADVANCE_WMS_BASE_URL}/updateVendor`,
	DELETE_VENDOR: `${ADVANCE_WMS_BASE_URL}/deleteVendor`,
	GET_PACK_LIST_BY_ITEMS: `${ADVANCE_WMS_BASE_URL}/getPackListByItems`,
	CLEAR_WAVE_BY_ID: `${ADVANCE_WMS_BASE_URL}/clearWaveDataByIDs`,
	GET_STOCK_UPDATE_LIST: `${REPORT_LIST_BASE_URL}/getStockUpdateList`,
	GET_ORDERS_BY_WAREHOUSE_AND_ORDER_TYPES: `${ADVANCE_WMS_BASE_URL}/getOrderListForWaveCreation`,
	CREATE_WAVE_FROM_WAVE_CREATION_PILOT: `${ADVANCE_WMS_BASE_URL}/createWaveFromWaveCreationPilot`
};

export const USER_GROUPS_MODULE = {
	GET_WMS_USER_GROUPS_LIST: `${USER_GROUPS_BASE_URL}/getUserGroups`,
	GET_WMS_USER_GROUP: `${USER_GROUPS_BASE_URL}/getUserGroup`,
	ADD_WMS_USER_GROUP: `${USER_GROUPS_BASE_URL}/addUserGroups`,
	UPDATE_WMS_USER_GROUP: `${USER_GROUPS_BASE_URL}/updateUserGroup`
};
export const DELIVERY_COMPANIES = {
	GET_DELIVERY_COMPANIES_LIST: `${DELIVERY_COMPANIES_BASE_URL}/getDeliveryCompaniesList`,
	ADD_DELIVERY_COMPANY: `${DELIVERY_COMPANIES_BASE_URL}/addDeliveryCompany`,
	UPDATE_DELIVERY_COMPANY: `${DELIVERY_COMPANIES_BASE_URL}/updateDeliveryCompany`,
	GET_DELIVERY_COMPANY: `${DELIVERY_COMPANIES_BASE_URL}/getDeliveryCompany`,
	DELETE_STATUS_HISTORY_ITEM: `${DELIVERY_COMPANIES_BASE_URL}/deleteDeliveryCompanyStatusItem`,
	DELETE_DELIVERY_COMPANY_SETTINGS_CONFIG_ITEM: `${DELIVERY_COMPANIES_BASE_URL}/deleteDeliveryCompanySettingsConfigItem`,
	GET_DC_SETTINGS_LIST_BY_DC_INTEGRATION: `${DELIVERY_COMPANIES_BASE_URL}/getDcSettingsListByDcIntegration`
};
export const ADDRESS = {
	// listings
	GET_ADDRESS: `${ADDRESS_BASE_URL}/getAddressByShortCode`,
	GET_TAG_REQUEST_LIST: `${ADDRESS_BASE_URL}/getTagRequests`,
	GET_COUNTRIES_LIST: `${ADDRESS_BASE_URL}/getCountriesList`,
	GET_CITIES_LIST: `${ADDRESS_BASE_URL}/getCitiesList`,
	GET_DISTRICTS_LIST: `${ADDRESS_BASE_URL}/getDistrictsList`,
	GET_STATES_LIST: `${ADDRESS_BASE_URL}/getStatesList`,
	GET_NEIGHBORHOODS_LIST: `${ADDRESS_BASE_URL}/getNeighbourhoodsList`,
	GET_GOVERNORATES_LIST: `${ADDRESS_BASE_URL}/getGovernoratesList`,
	DELETE_COUNTRY: `${ADDRESS_BASE_URL}/deleteCountry`,
	DELETE_STATE: `${ADDRESS_BASE_URL}/deleteState`,
	DELETE_CITY: `${ADDRESS_BASE_URL}/deleteCity`,
	DELETE_DISTRICT: `${ADDRESS_BASE_URL}/deleteDistrict`,
	DELETE_GOVERNORATE: `${ADDRESS_BASE_URL}/deleteGovernorate`,
	DELETE_NEIGHBORHOOD: `${ADDRESS_BASE_URL}/deleteNeighbourhood`,

	// dropdowns
	GET_COUNTRY_LIST: `${OPEN_BASE_URL}/getCountriesAutoComplete`,
	GET_STATES_BY_COUNTRY: `${OPEN_BASE_URL}/getStatesByCountryAutoComplete`,
	GET_CITIES_BY_STATE: `${OPEN_BASE_URL}/getCitiesByStateAutoComplete`,
	GET_DISTRICTS_BY_CITY: `${OPEN_BASE_URL}/getDistrictByCityAutoComplete`,
	GET_GOVERNORATES_BY_STATE: `${OPEN_BASE_URL}/getGovernoratesByStateAutoComplete`,
	GET_CITIES_BY_COUNTRY: `${OPEN_BASE_URL}/getCitiesByCountryAutoComplete`,
	GET_NEIGHBORHOODS_BY_DISTRICT: `${OPEN_BASE_URL}/getNeighbourhoodsByDistrictAutoComplete`,
	GOOGLE_GEOCODE_PARSE: `${OPEN_BASE_URL}/googleGeocodeParse`,
	DELIVERY_COMPANY_PARSE: `${ADDRESS_BASE_URL}/deliveryCompanyParse`,

	// new dropdowns
	GET_STATES: `${OPEN_BASE_URL}/getStatesByAutoComplete`,
	GET_GOVERNORATES: `${OPEN_BASE_URL}/getGovernoratesByAutoComplete`,
	GET_CITIES_BY_COUNTRY_WITH_KEYWORD: `${OPEN_BASE_URL}/getCitiesByCountryWithKeywordAutoComplete`,
	GET_CITIES: `${OPEN_BASE_URL}/getCitiesByAutoComplete`,
	GET_DISTRICTS: `${OPEN_BASE_URL}/getDistrictsByAutoComplete`,
	GET_NEIGHBORHOODS: `${OPEN_BASE_URL}/getNeighbourhoodsByAutoComplete`,

	// tags
	GET_COUNTRY_TAG_LIST: `${ADDRESS_BASE_URL}/getCountryTagList`,
	GET_STATE_TAG_LIST: `${ADDRESS_BASE_URL}/getStateTagList`,
	GET_CITY_TAG_LIST: `${ADDRESS_BASE_URL}/getCityTagList`,
	GET_DISTRICT_TAG_LIST: `${ADDRESS_BASE_URL}/getDistrictTagList`,
	GET_GOVERNORATE_TAG_LIST: `${ADDRESS_BASE_URL}/getGovernorateTagList`,
	GET_NEIGHBOURHOOD_TAG_LIST: `${ADDRESS_BASE_URL}/getNeighbourhoodTagList`,
	SAVE_COUNTRY: `${ADDRESS_BASE_URL}/saveCountry`,
	SAVE_STATE: `${ADDRESS_BASE_URL}/saveState`,
	SAVE_CITY: `${ADDRESS_BASE_URL}/saveCity`,
	SAVE_DISTRICT: `${ADDRESS_BASE_URL}/saveDistrict`,
	SAVE_NEIGHBORHOOD: `${ADDRESS_BASE_URL}/saveNeighbourhood`,
	SAVE_GOVERNORATE: `${ADDRESS_BASE_URL}/saveGovernorate`,
	ADD_TAG: `${ADDRESS_BASE_URL}/addTag`,
	REMOVE_TAG: `${ADDRESS_BASE_URL}/removeTag`,
	UPDATE_TAG_REQUEST: `${ADDRESS_BASE_URL}/updateTagRequestStatus`,

	// getDeliveryCompanies
	GET_CITY_DELIVERY_COMPANIES: `${ADDRESS_BASE_URL}/getCityDeliveryCompanies`,
	GET_DISTRICT_DELIVERY_COMPANIES: `${ADDRESS_BASE_URL}/getDistrictDeliveryCompanies`
};

export const PRICE_CONFIGURATIONS = {
	GET_SHIPPING_CONTRACT_LIST: `${PRICE_CALCULATOR_BASE_URL}/getShippingContractList`,
	GET_SHIPPING_CONTRACT: `${PRICE_CALCULATOR_BASE_URL}/getShippingContract`,
	ADD_SHIPPING_CONTRACT: `${PRICE_CALCULATOR_BASE_URL}/addShippingContract`,
	DELETE_SHIPPING_CONTRACT: `${PRICE_CALCULATOR_BASE_URL}/deleteShippingContract`,

	GET_OTO_DELIVERY_PRICE_LIST: `${PRICE_CALCULATOR_BASE_URL}/getOtoDeliveryPriceList`,
	GET_OTO_DELIVERY_PRICE: `${PRICE_CALCULATOR_BASE_URL}/getOtoDeliveryPrice`,
	ADD_OTO_DELIVERY_PRICE: `${PRICE_CALCULATOR_BASE_URL}/addOtoDeliveryPrice`,
	DELETE_OTO_DELIVERY_PRICE: `${PRICE_CALCULATOR_BASE_URL}/deleteOtoDeliveryPrice`,

	GET_SPECIAL_CONTRACT_TERM_LIST: `${PRICE_CALCULATOR_BASE_URL}/getSpecialContractTermList`,
	GET_SPECIAL_CONTRACT_TERM: `${PRICE_CALCULATOR_BASE_URL}/getSpecialContractTerm`,
	ADD_SPECIAL_CONTRACT_TERM: `${PRICE_CALCULATOR_BASE_URL}/addSpecialContractTerm`,
	DELETE_SPECIAL_CONTRACT_TERM: `${PRICE_CALCULATOR_BASE_URL}/deleteSpecialContractTerm`,

	GET_DC_WORKING_HOURS: `${PRICE_CALCULATOR_BASE_URL}/getDcWorkingHoursList`,
	ADD_DC_WORKING_HOURS: `${PRICE_CALCULATOR_BASE_URL}/addDcWorkingHours`,
	DELETE_DC_WORKING_HOURS: `${PRICE_CALCULATOR_BASE_URL}/deleteDcWorkingHours`,

	GET_TIER_BASED_PRICE_LIST: `${PRICE_CALCULATOR_BASE_URL}/getTierBasedPriceList`,
	GET_TIER_BASED_PRICE: `${PRICE_CALCULATOR_BASE_URL}/getTierBasedPrice`,
	ADD_TIER_BASED_PRICE: `${PRICE_CALCULATOR_BASE_URL}/addTierBasedPrice`,
	DELETE_TIER_BASED_PRICE: `${PRICE_CALCULATOR_BASE_URL}/deleteTierBasedPrice`,

	GET_WEIGHT_BASED_PRICE_LIST: `${PRICE_CALCULATOR_BASE_URL}/getWeightBasedPriceList`,
	GET_WEIGHT_BASED_PRICE: `${PRICE_CALCULATOR_BASE_URL}/getWeightBasedPrice`,
	ADD_WEIGHT_BASED_PRICE: `${PRICE_CALCULATOR_BASE_URL}/addWeightBasedPrice`,
	DELETE_WEIGHT_BASED_PRICE: `${PRICE_CALCULATOR_BASE_URL}/deleteWeightBasedPrice`,

	GET_SHIPPING_CONTRACT_AUTOCOMPLETE_LIST: `${PRICE_CALCULATOR_BASE_URL}/getShippingContractAutoCompleteList`,
	GET_SHIPPING_CONTRACT_AUTOCOMPLETE_FOR_INSTRUCTION: `${PRICE_CALCULATOR_BASE_URL}/getShippingContractAutoCompleteForInstruction`,
	GET_WEIGHT_COUNTRY_BASED_PRICE_LIST: `${PRICE_CALCULATOR_BASE_URL}/getWeightCountryBasedPriceList`,
	GET_WEIGHT_COUNTRY_BASED_PRICE: `${PRICE_CALCULATOR_BASE_URL}/getWeightCountryBasedPrice`,
	ADD_WEIGHT_COUNTRY_BASED_PRICE: `${PRICE_CALCULATOR_BASE_URL}/addWeightCountryBasedPrice`,
	DELETE_WEIGHT_COUNTRY_BASED_PRICE: `${PRICE_CALCULATOR_BASE_URL}/deleteWeightCountryBasedPrice`,

	GET_CITY_BASED_PRICE_LIST: `${PRICE_CALCULATOR_BASE_URL}/getCityBasedPriceList`,
	GET_CITY_BASED_PRICE: `${PRICE_CALCULATOR_BASE_URL}/getCityBasedPrice`,
	ADD_CITY_BASED_PRICE: `${PRICE_CALCULATOR_BASE_URL}/addCityBasedPrice`,
	DELETE_CITY_BASED_PRICE: `${PRICE_CALCULATOR_BASE_URL}/deleteCityBasedPrice`,

	GET_KM_BASED_PRICE_LIST: `${PRICE_CALCULATOR_BASE_URL}/getKmBasedPriceList`,
	GET_KM_BASED_PRICE: `${PRICE_CALCULATOR_BASE_URL}/getKmBasedPrice`,
	ADD_KM_BASED_PRICE: `${PRICE_CALCULATOR_BASE_URL}/addKmBasedPrice`,
	DELETE_KM_BASED_PRICE: `${PRICE_CALCULATOR_BASE_URL}/deleteKmBasedPrice`,

	GET_KM_BASED_SLA_LIST: `${PRICE_CALCULATOR_BASE_URL}/getKmBasedSlaList`,
	GET_KM_BASED_SLA: `${PRICE_CALCULATOR_BASE_URL}/getKmBasedSla`,
	ADD_KM_BASED_SLA: `${PRICE_CALCULATOR_BASE_URL}/addKmBasedSla`,
	DELETE_KM_BASED_SLA: `${PRICE_CALCULATOR_BASE_URL}/deleteKmBasedSla`,

	GET_BULLET_KM_SLA_LIST: `${PRICE_CALCULATOR_BASE_URL}/getBulletKmSlaList`,
	GET_BULLET_KM_SLA: `${PRICE_CALCULATOR_BASE_URL}/getBulletKmSla`,
	ADD_BULLET_KM_SLA: `${PRICE_CALCULATOR_BASE_URL}/addBulletKmSla`,
	DELETE_BULLET_KM_SLA: `${PRICE_CALCULATOR_BASE_URL}/deleteBulletKmSla`,

	GET_TIER_BASED_SLA_LIST: `${PRICE_CALCULATOR_BASE_URL}/getTierBasedSlaList`,
	GET_TIER_BASED_SLA: `${PRICE_CALCULATOR_BASE_URL}/getTierBasedSla`,
	ADD_TIER_BASED_SLA: `${PRICE_CALCULATOR_BASE_URL}/addTierBasedSla`,
	DELETE_TIER_BASED_SLA: `${PRICE_CALCULATOR_BASE_URL}/deleteTierBasedSla`,

	GET_DISTRICT_BASED_SLA_LIST: `${PRICE_CALCULATOR_BASE_URL}/getDistrictBasedSlaList`,
	GET_DISTRICT_BASED_SLA: `${PRICE_CALCULATOR_BASE_URL}/getDistrictBasedSla`,
	ADD_DISTRICT_BASED_SLA: `${PRICE_CALCULATOR_BASE_URL}/addDistrictBasedSla`,
	DELETE_DISTRICT_BASED_SLA: `${PRICE_CALCULATOR_BASE_URL}/deleteDistrictBasedSla`,

	GET_CITY_BASED_SLA_LIST: `${PRICE_CALCULATOR_BASE_URL}/getCityBasedSlaList`,
	GET_CITY_BASED_SLA: `${PRICE_CALCULATOR_BASE_URL}/getCityBasedSla`,
	ADD_CITY_BASED_SLA: `${PRICE_CALCULATOR_BASE_URL}/addCityBasedSla`,
	DELETE_CITY_BASED_SLA: `${PRICE_CALCULATOR_BASE_URL}/deleteCityBasedSla`,

	GET_COUNTRY_BASED_SLA_LIST: `${PRICE_CALCULATOR_BASE_URL}/getCountryBasedSlaList`,
	GET_COUNTRY_BASED_SLA: `${PRICE_CALCULATOR_BASE_URL}/getCountryBasedSla`,
	ADD_COUNTRY_BASED_SLA: `${PRICE_CALCULATOR_BASE_URL}/addCountryBasedSla`,
	DELETE_COUNTRY_BASED_SLA: `${PRICE_CALCULATOR_BASE_URL}/deleteCountryBasedSla`,

	GET_OTO_MARGIN_PRICE_LIST: `${PRICE_CALCULATOR_BASE_URL}/getOtoMarginPriceList`,
	GET_OTO_MARGIN_PRICE: `${PRICE_CALCULATOR_BASE_URL}/getOtoMarginPrice`,
	ADD_OTO_MARGIN_PRICE: `${PRICE_CALCULATOR_BASE_URL}/addOtoMarginPrice`,
	DELETE_OTO_MARGIN_PRICE: `${PRICE_CALCULATOR_BASE_URL}/deleteOtoMarginPrice`,

	GET_PRICE_NOT_FOUND_ORDERS_LIST: `${ACCOUNTING_BASE_URL}/getPriceNotFoundOrdersList`,
	ADD_PRICE_MANUALLY: `${ACCOUNTING_BASE_URL}/addPriceManually`,
	DELETE_PRICE_NOT_FOUND_ORDERS: `${ACCOUNTING_BASE_URL}/deletePriceNotFoundOrders`,

	GET_PRICE_LIST: `${PRICE_CALCULATOR_BASE_URL}/getPriceList`,
	GET_PRICE_LIST_OPEN: `${OPEN_BASE_URL}/getPriceList`,

	GET_SUCCESS_INSTRUCTIONS_LIST: `${PRICE_CALCULATOR_BASE_URL}/getSuccessInstructionList`,
	GET_SUCCESS_INSTRUCTION: `${PRICE_CALCULATOR_BASE_URL}/getSuccessInstruction`,
	ADD_SUCCESS_INSTRUCTION: `${PRICE_CALCULATOR_BASE_URL}/addSuccessInstruction`,
	DELETE_SUCCESS_INSTRUCTION: `${PRICE_CALCULATOR_BASE_URL}/deleteSuccessInstruction`,

	BULLET_CONFIRMATION: `${PRICE_CALCULATOR_BASE_URL}/bulletConfirmation`,

	// AutoCompletes
	GET_DELIVERY_COMPANY_SETTINGS_AUTOCOMPLETE_LIST: `${PRICE_CALCULATOR_BASE_URL}/getDeliveryCompanySettings`,
	GET_DELIVERY_COMPANY_AUTOCOMPLETE: `${PRICE_CALCULATOR_BASE_URL}/getDeliveryCompanyAutoCompleteList`,
	GET_ADVANCED_DELIVERY_COMPANY_AUTOCOMPLETE: `${PRICE_CALCULATOR_BASE_URL}/getAdvancedDeliveryCompanyAutoCompleteList`,

	// Listings
	GET_AGGREGATOR_SHIPMENT_LIST: `${PRICE_CALCULATOR_BASE_URL}/getAggregatorShipmentList`,
	GET_RECONCILIATION_LIST: `${INVOICE_CHECKER_BASE_URL}/getReconciliationList`,
	GET_CLOSED_SHIPMENTS_LIST: `${INVOICE_CHECKER_BASE_URL}/getClosedShipmentsList`,
	GET_WEIGHT_CORR_CLOSED_LIST: `${INVOICE_CHECKER_BASE_URL}/getWeightCorrectorClosedList`,
	GET_WEIGHT_CORR_OPEN_LIST: `${INVOICE_CHECKER_BASE_URL}/getWeightCorrectorOpenList`,

	// Actions
	DONT_CHARGE: `${INVOICE_CHECKER_BASE_URL}/dontChargeAction`,
	CHARGE_CORRECTION: `${INVOICE_CHECKER_BASE_URL}/chargeCorrectionAction`,
	MIGRATE_SHIPPING_CONTRACT: `${PRICE_CALCULATOR_BASE_URL}/copyShippingContract`,

	// Price Configuration
	IMPORT_OTO_DELIVERY_PRICE_IMPORT: `${PRICE_CALCULATOR_BASE_URL}/importOtoDeliveryPrice`,
	IMPORT_SHIPPING_CONTRACT_IMPORT: `${PRICE_CALCULATOR_BASE_URL}/importShippingContract`,
	IMPORT_SPECIAL_CONTRACT_TERM_IMPORT: `${PRICE_CALCULATOR_BASE_URL}/importSpecialContractTerm`,
	IMPORT_TIER_BASED_PRICE_IMPORT: `${PRICE_CALCULATOR_BASE_URL}/importTierBasedPrice`,
	IMPORT_CITY_BASED_PRICE_IMPORT: `${PRICE_CALCULATOR_BASE_URL}/importCityBasedPrice`,
	IMPORT_KM_BASED_PRICE_IMPORT: `${PRICE_CALCULATOR_BASE_URL}/importKmBasedPrice`,
	IMPORT_WEIGHT_BASED_PRICE_IMPORT: `${PRICE_CALCULATOR_BASE_URL}/importWeightBasedPrice`,
	IMPORT_WEIGHT_COUNTRY_BASED_PRICE_IMPORT: `${PRICE_CALCULATOR_BASE_URL}/importWeightCountryBasedPrice`,
	IMPORT_TIER_BASED_SLA_IMPORT: `${PRICE_CALCULATOR_BASE_URL}/importTierBasedSla`,
	IMPORT_KM_BASED_SLA_IMPORT: `${PRICE_CALCULATOR_BASE_URL}/importKmBasedSla`,
	IMPORT_BULLET_KM_SLA_IMPORT: `${PRICE_CALCULATOR_BASE_URL}/importBulletKmSla`,
	IMPORT_DISTRICT_BASED_SLA_IMPORT: `${PRICE_CALCULATOR_BASE_URL}/importDistrictBasedSla`,
	IMPORT_CITY_BASED_SLA_IMPORT: `${PRICE_CALCULATOR_BASE_URL}/importCityBasedSla`,
	IMPORT_COUNTRY_BASED_SLA_IMPORT: `${PRICE_CALCULATOR_BASE_URL}/importCountryBasedSla`,
	IMPORT_OTO_MARGIN_PRICE: `${PRICE_CALCULATOR_BASE_URL}/importOtoMarginPrice`,
	IMPORT_INVOICE_CHECKER_DELIVERY_COMPANY: `${IMPORT_BASE_URL}/importInvoiceCheckerDeliveryCompany`,
	IMPORT_INVOICE_CHECKER_DAILY_WEIGHT: `${IMPORT_BASE_URL}/importInvoiceCheckerDailyWeight`,
	IMPORT_SUCCESS_INSTRUCTION: `${PRICE_CALCULATOR_BASE_URL}/importSuccessInstruction`,

	GET_OTO_DELIVERY_PRICE_TEMPLATE: `${PRICE_CALCULATOR_BASE_URL}/getOtoDeliveryPriceTemplate`,
	GET_SHIPPING_CONTRACT_TEMPLATE: `${PRICE_CALCULATOR_BASE_URL}/getShippingContractTemplate`,
	GET_SPECIAL_CONTRACT_TERM_TEMPLATE: `${PRICE_CALCULATOR_BASE_URL}/getSpecialContractTermTemplate`,
	GET_TIER_BASED_PRICE_TEMPLATE: `${PRICE_CALCULATOR_BASE_URL}/getTierBasedPriceTemplate`,
	GET_CITY_BASED_PRICE_TEMPLATE: `${PRICE_CALCULATOR_BASE_URL}/getCityBasedPriceTemplate`,
	GET_KM_BASED_PRICE_TEMPLATE: `${PRICE_CALCULATOR_BASE_URL}/getKmBasedPriceTemplate`,
	GET_WEIGHT_COUNTRY_BASED_PRICE_TEMPLATE: `${PRICE_CALCULATOR_BASE_URL}/getWeightCountryBasedPriceTemplate`,
	GET_WEIGHT_BASED_PRICE_TEMPLATE: `${PRICE_CALCULATOR_BASE_URL}/getWeightBasedPriceTemplate`,
	GET_KM_BASED_SLA_TEMPLATE: `${PRICE_CALCULATOR_BASE_URL}/getKmBasedSlaTemplate`,
	GET_BULLET_KM_SLA_TEMPLATE: `${PRICE_CALCULATOR_BASE_URL}/getBulletKmSlaTemplate`,
	GET_TIER_BASED_SLA_TEMPLATE: `${PRICE_CALCULATOR_BASE_URL}/getTierBasedSlaTemplate`,
	GET_DISTRICT_BASED_SLA_TEMPLATE: `${PRICE_CALCULATOR_BASE_URL}/getDistrictBasedSlaTemplate`,
	GET_CITY_BASED_SLA_TEMPLATE: `${PRICE_CALCULATOR_BASE_URL}/getCityBasedSlaTemplate`,
	GET_COUNTRY_BASED_SLA_TEMPLATE: `${PRICE_CALCULATOR_BASE_URL}/getCountryBasedSlaTemplate`,
	GET_OTO_MARGIN_PRICE_TEMPLATE: `${PRICE_CALCULATOR_BASE_URL}/getOtoMarginPriceTemplate`,
	GET_INVOICE_CHECKER_DELIVERY_COMPANY_TEMPLATE: `${IMPORT_BASE_URL}/getInvoiceCheckerDeliveryCompanyTemplate`,
	GET_INVOICE_CHECKER_DAILY_WEIGHT_TEMPLATE: `${IMPORT_BASE_URL}/getInvoiceCheckerDailyWeightTemplate`,
	GET_SUCCESS_INSTRUCTION_TEMPLATE: `${PRICE_CALCULATOR_BASE_URL}/getSuccessInstructionTemplate`,

	ADD_LOCKER_DIMENSIONS: `${PRICE_CALCULATOR_BASE_URL}/addLocker`,

	GET_SAVINGS_CALCULATOR_DC_LIST: `${PRICE_CALCULATOR_BASE_URL}/getSavingsCalculatorDeliveryCompanyList`,
	GET_SAVINGS_CALCULATOR_RESULT: `${PRICE_CALCULATOR_BASE_URL}/getSavingsCalculatorResult`
};

export const COD_WALLET = {
	GET_COD_WALLET_DASHBOARD_OVERVIEW: `${COD_WALLET_BASE_URL}/getCODWalletDashboardOverview`,
	GET_COD_DASHBOARD_LIST: `${COD_WALLET_BASE_URL}/getCODDashboardList`,
	TRANSFER_TO_BANK_ACCOUNT: `${COD_WALLET_BASE_URL}/transferToBankAccount`,
	GET_TRANSFER_TO_BANK_NOTIFICATION: `${COD_WALLET_BASE_URL}/getTransferToBankNotification`,
	GET_TRANSACTION_STATUS_LOGS_BY_ID: `${COD_WALLET_BASE_URL}/getCodWalletTransactionLogsByID`
};

export const AUTOMATION = {
	GET_AUTOMATION_LIST: `${AUTOMATION_BASE_URL}/getAutomationList`,
	GET_AUTOMATION_BY_ID: `${AUTOMATION_BASE_URL}/getAutomationById`,
	ADD_AUTOMATION: `${AUTOMATION_BASE_URL}/addAutomation`,
	UPDATE_AUTOMATION: `${AUTOMATION_BASE_URL}/updateAutomation`
};

export const FINANCE = {
	GET_BANK_LIST: `${FINANCE_BASE_URL}/getBankList`,
	GET_BANK: `${FINANCE_BASE_URL}/getBank`,
	ADD_BANK: `${FINANCE_BASE_URL}/addBank`,
	UPDATE_BANK: `${FINANCE_BASE_URL}/updateBank`,
	DELETE_BANK: `${FINANCE_BASE_URL}/deleteBank`,

	GET_BANK_TRANSFER_LIST: `${FINANCE_BASE_URL}/getBankTransferList`,
	APPROVE_BANK_TRANSFER: `${FINANCE_BASE_URL}/approveBankTransfer`,
	REJECT_BANK_TRANSFER: `${FINANCE_BASE_URL}/rejectBankTransfer`,

	GET_NEW_COD_REPORTS_LIST: `${FINANCE_BASE_URL}/getNewCODReportsList`,
	UPDATE_COD_REPORT_NEW_REPORT: `${FINANCE_BASE_URL}/updateCODReportNewReport`,
	UPDATE_COD_REPORT_CASH_DEPOSITED: `${FINANCE_BASE_URL}/updateCODReportCashDeposited`,
	UPDATE_COD_REPORT_APPROVED: `${FINANCE_BASE_URL}/updateCODReportApproved`,
	DELETE_COD_REPORT_BY_TYPE: `${FINANCE_BASE_URL}/deleteCODReportByType`,

	GET_COD_REPORT_DETAILS: `${FINANCE_BASE_URL}/getCODReportDetails`,
	ADD_COD_PAYABLE_REPORT: `${FINANCE_BASE_URL}/addCODPayableReport`,
	UPDATE_COD_PAYABLE_REPORT: `${FINANCE_BASE_URL}/updateCODPayableReport`,

	GET_CLIENT_TRANSACTIONS: `${FINANCE_BASE_URL}/getTransactionList`,
	GET_REFUND_TRANSACTIONS: `${FINANCE_BASE_URL}/getRefundTransaction`,
	ADD_CLIENT_TRANSACTIONS: `${FINANCE_BASE_URL}/addClientTransaction`,

	GET_APPROVED_COD_REPORTS_LIST: `${FINANCE_BASE_URL}/getApprovedCODReportsList`,

	GET_CASH_DEPOSITED_REPORTS_LIST: `${FINANCE_BASE_URL}/getCashDepositedReportsList`,

	GENERATE_COD_REPORT: `${FINANCE_BASE_URL}/generateCODReport`,
	GET_NEW_RECEIVABLE_REPORTS_LIST: `${FINANCE_BASE_URL}/getNewReceivableReportList`,
	GET_NO_CONFLICT_LIST: `${FINANCE_BASE_URL}/getNoConflictList`,
	GET_RECEIVED_OTO_BANK_FROM_DC_LIST: `${FINANCE_BASE_URL}/getReceivedOTOBankFromDCList`,
	GET_WAITING_RECONCILATION_ORDERS_LIST: `${FINANCE_BASE_URL}/getWaitingReconciliationOrderList`,
	GET_RECONCILED_ORDERS_LIST: `${FINANCE_BASE_URL}/getReconciledOrderList`,
	MARK_RECONCILED_COD_RECEIVABLE: `${FINANCE_BASE_URL}/markAsReconciledCODReceivable`,
	MARK_NO_CONFLICT_COD_RECEIVABLE: `${FINANCE_BASE_URL}/markAsNoConflictCODReceivable`,
	MARK_RECEIVED_COD_RECEIVABLE: `${FINANCE_BASE_URL}/markAsReceivedCODReceivable`,
	RECEIVE_COD_RECEIVABLE: `${FINANCE_BASE_URL}/receiveCODReceivableReport`,
	RECONCILE_COD_RECEIVABLE: `${FINANCE_BASE_URL}/reconcileCODReceivableReport`,
	DELETE_COD_RECEIVABLE: `${FINANCE_BASE_URL}/deleteCODReceivable`,
	GET_COD_RECEIVABLE_DETAILS: `${FINANCE_BASE_URL}/getCODReceivableDetails`,
	UPDATE_COD_RECEIVABLE_REPORT: `${FINANCE_BASE_URL}/updateCODReceivableReport`,
	UPLOAD_PAYMENT_SLIP_COD_RECEIVABLE: `${FINANCE_BASE_URL}/uploadPaymentSlip`,
	GENERATE_COD_RECEIVABLE: `${FINANCE_BASE_URL}/generateCODReceivable`,

	GET_FAILED_BANK_TRANSFER_LIST: `${FINANCE_BASE_URL}/getFailedBankTransferList`,
	GET_PROCESSING_BANK_TRANSFER_LIST: `${FINANCE_BASE_URL}/getProcessingBankTransferList`,
	GET_ALL_WITHDRAWALS_LIST: `${FINANCE_BASE_URL}/getAllWithdrawalsList`,

	UPDATE_CLIENT_AUTOMATIC_COD_TRANSFER: `${FINANCE_BASE_URL}/updateClientAutomaticCODTransfer`,
	UPDATE_COD_WALLET_TRANSACTION_STATUS: `${FINANCE_BASE_URL}/updateCODWalletTransactionStatus`,
	FETCH_COD_WALLET_TRANSACTION_BANK_INFOS: `${FINANCE_BASE_URL}/fetchCODWalletTransactionBankInfos`,
	UPDATE_COD_WALLET_TRANSACTION_DESCRIPTION: `${FINANCE_BASE_URL}/updateCODWalletTransactionDescription`,

	MARK_AS_WITHDRAW_REQUESTED: `${FINANCE_BASE_URL}/markAsWithdrawRequested`,

	GET_UNIT_ECONOMIC_TOTALS_BY_COUNTRY: `${UNIT_ECONOMICS_BASE_URL}/getUnitEconomicTotalsByCountry`,
	GET_UNIT_ECONOMIC_DELIVERY_COMPANY_PL_ANALYSIS: `${UNIT_ECONOMICS_BASE_URL}/getUnitEconomicDeliveryCompanyPLAnalysis`,
	GET_UNIT_ECONOMIC_DC_TIME_ANALYSIS: `${UNIT_ECONOMICS_BASE_URL}/getUnitEconomicDCTimeAnalysis`,
	GET_UNIT_ECONOMIC_CLIENT_ANALYSIS_LIST: `${UNIT_ECONOMICS_BASE_URL}/getUnitEconomicClientAnalysisList`,
	GET_UNIT_ECONOMIC_AGGREGATOR_INVOICE_LIST: `${UNIT_ECONOMICS_BASE_URL}/getUnitEconomicAggregatorInvoiceList`,
	GET_UNIT_ECONOMIC_DC_PROFITABILITY: `${UNIT_ECONOMICS_BASE_URL}/getUnitEconomicDCProfitability`,

	GET_OTO_LINK_TRANSACTIONS: `${FINANCE_BASE_URL}/getOTOLinkTransactions`,

	UPDATE_CREDIT_TRANSACTIONS: `${FINANCE_BASE_URL}/updateCreditTransactions`,
	GET_TRANSACTION_INFORMATION_FOR_UPDATE: `${FINANCE_BASE_URL}/getTransactionInformationForUpdate`,
	REACTIVATE_TRANSACTION: `${FINANCE_BASE_URL}/reactivateTransaction`,
	CANCEL_TRANSACTION: `${FINANCE_BASE_URL}/cancelTransaction`
};

export const MFA = {
	ENABLE_MFA: `${MFA_BASE_URL}/enableTOTP`,
	DISABLE_MFA: `${MFA_BASE_URL}/disableTOTP`,
	ACTIVATE_MFA: `${MFA_BASE_URL}/activateTOTP`,
	REGENERATE_RECOVERY_CODES: `${MFA_BASE_URL}/regenerateRecoveryCode`,
	SEND_2FA_BACKUP_CODES: `${MFA_BASE_URL}/send2FABackupCodes`
};

export const SOUND = {
	BARCODE_SUCCESS: `${STORAGE_PUBLIC}/sounds/barcode-success.mp3`,
	BARCODE_ERROR: `${STORAGE_PUBLIC}/sounds/barcode-error.wav`
};

export const MARKETING = {
	GET_PROMO_CODES_LIST: `${MARKETING_BASE_URL}/promoCodes/getPromoCodes`,
	GET_PROMO_TRANSACTIONS_LIST: `${MARKETING_BASE_URL}/promoCodes/getPromoTransactions`,
	GET_PROMO_CODE_DETAILS: `${MARKETING_BASE_URL}/promoCodes/getPromoCodeDetails`,
	UPDATE_PROMO_CODE: `${MARKETING_BASE_URL}/promoCodes/updatePromoCode`,
	CREATE_PROMO_CODE: `${MARKETING_BASE_URL}/promoCodes/createPromoCode`
};
export const SALES_CHANNELS = {
	GET_SALE_CHANNELS: `${SALE_CHANNEL_BASE_URL}/getSaleChannels`,
	GET_SALE_CHANNELS_BY_SLUG: `${SALE_CHANNEL_BASE_URL}/getSalesChannelBySlug`,
	GET_SALE_CHANNEL_BY_COMPANY: `${SALE_CHANNEL_BASE_URL}/getSaleChannelByCompany`,
	GET_SALES_CHANNEL_OTO_API: `${SALE_CHANNEL_BASE_URL}/getSalesChannelByCompanyOtoApi`,
	GET_CONNECTED_SALLA_CHANNELS: `${SALE_CHANNEL_BASE_URL}/getSallaAutomations`,
	DELETE_SALE_CHANNEL: `${SALE_CHANNEL_BASE_URL}/deleteSaleChannelCredential`,
	UPDATE_SALE_CHANNEL_STATUS: `${SALE_CHANNEL_BASE_URL}/updateSaleChannelStatus`,
	TEST_CONNECTION_SERVICE: `${SALE_CHANNEL_BASE_URL}/testSCConnection`,
	ADD_SALES_CHANNEL_CREDENTIALS: `${SALE_CHANNEL_BASE_URL}/addSalesChannelCredentials`,
	GET_SALES_CHANNEL_CREDENTIALS: `${SALE_CHANNEL_BASE_URL}/getSalesChannelCredentials`,
	UPDATE_SALES_CHANNEL_CREDENTIALS: `${SALE_CHANNEL_BASE_URL}/updateSalesChannelCredentials`,
	AUTHORIZE_SALES_CHANNEL: `${SALE_CHANNEL_BASE_URL}/authorize`,
	GENERATE_CREDENTIALS_V1: `${SALE_CHANNEL_BASE_URL}/generateCredentialsV1`,
	GET_LOCATION_MAPPING: `${SALE_CHANNEL_BASE_URL}/getLocationMapping`,
	GET_WAREHOUSE_AND_BRANCH_LIST: `${SALE_CHANNEL_BASE_URL}/getWarehouseAndBranchList`,
	SAVE_LOCATION_MAPPING: `${SALE_CHANNEL_BASE_URL}/saveLocationMapping`,
	GET_STATUS_MAPPING: `${SALE_CHANNEL_BASE_URL}/getSalesChannelStatusMapping`,
	UPDATE_STATUS_MAPPING: `${SALE_CHANNEL_BASE_URL}/updateSalesChannelStatusMapping`,
	GET_SALLA_AUTOMATION_UPDATES: `${SALE_CHANNEL_BASE_URL}/getSallaAutomationUpdates`,
	UPDATE_SALLA_AUTOMATION_LOGS: `${SALE_CHANNEL_BASE_URL}/updateSallaAutomationIntegrationLogs`,
	GET_INVENTORY_CONF_BY_SALECHANNEL: `${INVENTORY_SYNC_BASE_URL}/getInventoryConfBySalesChannel`,
	UPDATE_INVENTORY_CONF_BY_SALECHANNEL: `${INVENTORY_SYNC_BASE_URL}/updateInventoryConfBySalesChannel`,
	LOG_ECOMMERCE: `${SALE_CHANNEL_BASE_URL}/logEcommerce`,
	GET_SALLA_STORE_INFO_DESKTOP: `${SALE_CHANNEL_BASE_URL}/getSallaStoreInfoDesktop`,
	SET_SALLA_STORE_INFO_DESKTOP: `${SALE_CHANNEL_BASE_URL}/setSallaStoreInfoDesktop`
};
export const IMPORT = {
	GET_IMPORT_ORDERS_LIST: `${IMPORT_ORDERS_ACTIONS_BASE_URL}/getImportOrders`,
	ADD_IMPORT_ORDER: `${IMPORT_ORDERS_ACTIONS_BASE_URL}/addImportOrder`,
	UPDATE_IMPORT_ORDER: `${IMPORT_ORDERS_ACTIONS_BASE_URL}/updateImportOrder`,
	CREATE_IMPORT_SHIPMENT: `${IMPORT_ORDERS_ACTIONS_BASE_URL}/createImportShipment`
};
